import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { LogOut, Home, GraduationCap, Flame, Bookmark, Users, PlayCircle, HelpCircle, Share2, Settings, ChevronRight, ChevronLeft, Play, Lock, ExternalLink, Dumbbell, TrendingUp, Video, Film, Bot, Apple, BookOpen, X, CheckCircle2, Info, Phone, Calendar, ArrowRight, Save, FileText, Presentation, User, RotateCcw, Plus, Trash2, Zap, Target, Droplets, Brain, UtensilsCrossed, BookOpenCheck } from 'lucide-react';
import { formationModules, trainers } from '../data/formations';
import { useT } from '../i18n/useT';

const API = process.env.REACT_APP_BACKEND_URL;
const TELEGRAM_URL = 'https://t.me/+fIG91M0qHRwxZGI0';

// Auth helper — returns headers with JWT token
const getAuthHeaders = (extra = {}) => {
  const token = localStorage.getItem('token');
  return { ...extra, ...(token ? { 'Authorization': `Bearer ${token}` } : {}) };
};

const iconMap = { Dumbbell, TrendingUp, Video, Film, Bot, Apple };

// ─── SLIDE GENERATOR ───
// ─── SLIDE IMAGE POOLS (musculation sections) ───
const slideImagePools = {
  'Les Fondamentaux de la Musculation': [
    'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=800&q=80',
    'https://images.pexels.com/photos/4720780/pexels-photo-4720780.jpeg?auto=compress&w=800',
    'https://images.unsplash.com/photo-1766287453739-c3ffc3f37d05?w=800&q=80',
    'https://images.pexels.com/photos/6046983/pexels-photo-6046983.png?auto=compress&w=800',
  ],
  'Sécurité et Technique': [
    'https://images.pexels.com/photos/6339459/pexels-photo-6339459.jpeg?auto=compress&w=800',
    'https://images.unsplash.com/photo-1758875569256-f37c438cac65?w=800&q=80',
    'https://images.unsplash.com/photo-1602750875843-407b4851efdd?w=800&q=80',
  ],
  'Les Exercices Fondamentaux': [
    'https://images.unsplash.com/photo-1770664612843-b44e26070024?w=800&q=80',
    'https://images.pexels.com/photos/2261477/pexels-photo-2261477.jpeg?auto=compress&w=800',
    'https://images.pexels.com/photos/4720794/pexels-photo-4720794.jpeg?auto=compress&w=800',
    'https://images.unsplash.com/photo-1765302762700-81992a568be5?w=800&q=80',
  ],
  'Planification de l\'Entraînement': [
    'https://images.pexels.com/photos/4164514/pexels-photo-4164514.jpeg?auto=compress&w=800',
    'https://images.unsplash.com/photo-1765728617086-5d16a7bac916?w=800&q=80',
    'https://images.unsplash.com/photo-1694579421795-321d349bacf0?w=800&q=80',
  ],
  'Nutrition pour la Musculation': [
    'https://images.unsplash.com/photo-1762631383378-115f2d4cbe07?w=800&q=80',
    'https://images.unsplash.com/photo-1762631934518-f75e233413ca?w=800&q=80',
    'https://images.pexels.com/photos/6066052/pexels-photo-6066052.jpeg?auto=compress&w=800',
    'https://images.pexels.com/photos/36275016/pexels-photo-36275016.jpeg?auto=compress&w=800',
  ],
  'La Récupération': [
    'https://images.pexels.com/photos/4804294/pexels-photo-4804294.jpeg?auto=compress&w=800',
    'https://images.pexels.com/photos/27730476/pexels-photo-27730476.jpeg?auto=compress&w=800',
    'https://images.unsplash.com/photo-1758521959379-2790549dabc3?w=800&q=80',
  ],
  'Programmes d\'Entraînement Concrets': [
    'https://images.pexels.com/photos/841130/pexels-photo-841130.jpeg?auto=compress&w=800',
    'https://images.unsplash.com/photo-1770664612843-b44e26070024?w=800&q=80',
    'https://images.pexels.com/photos/4720780/pexels-photo-4720780.jpeg?auto=compress&w=800',
    'https://images.unsplash.com/photo-1766287453739-c3ffc3f37d05?w=800&q=80',
  ],
  'Compléments Alimentaires': [
    'https://images.pexels.com/photos/15120889/pexels-photo-15120889.jpeg?auto=compress&w=800',
    'https://images.pexels.com/photos/33921585/pexels-photo-33921585.jpeg?auto=compress&w=800',
  ],
  'Suivi et Progression': [
    'https://images.pexels.com/photos/8155196/pexels-photo-8155196.jpeg?auto=compress&w=800',
    'https://images.unsplash.com/photo-1758875568756-37a9c5c1a4f2?w=800&q=80',
    'https://images.pexels.com/photos/19025674/pexels-photo-19025674.jpeg?auto=compress&w=800',
  ],
  'Plateaux et Motivation': [
    'https://images.pexels.com/photos/29667299/pexels-photo-29667299.jpeg?auto=compress&w=800',
    'https://images.pexels.com/photos/10929340/pexels-photo-10929340.jpeg?auto=compress&w=800',
    'https://images.unsplash.com/photo-1669504243706-1df1f8d5dacd?w=800&q=80',
  ],
  'Applications et Outils Recommandés': [
    'https://images.unsplash.com/photo-1758875568756-37a9c5c1a4f2?w=800&q=80',
    'https://images.pexels.com/photos/8155196/pexels-photo-8155196.jpeg?auto=compress&w=800',
  ],
  // ─── LISA — E-COMMERCE & RÉSEAUX SOCIAUX (OFFKA) ───
  'Mon Parcours & Les Bases': [
    'https://cdn.shopify.com/s/files/1/0651/5985/6347/files/IMG_9476.jpg?v=1761742066',
    'https://cdn.shopify.com/s/files/1/0651/5985/6347/files/maillot_offka_rose.jpg?v=1761742066',
    'https://cdn.shopify.com/s/files/1/0651/5985/6347/files/maillotlovelypassion.jpg?v=1761741774',
    'https://cdn.shopify.com/s/files/1/0651/5985/6347/files/IMG_9586-2.jpg?v=1761742066',
  ],
  'Créer ta Boutique E-commerce': [
    'https://cdn.shopify.com/s/files/1/0651/5985/6347/files/IMG_9227.jpg?v=1761739977',
    'https://cdn.shopify.com/s/files/1/0651/5985/6347/files/marbella_black_3.jpg?v=1761739977',
    'https://cdn.shopify.com/s/files/1/0651/5985/6347/files/IMG_9304.jpg?v=1761741114',
    'https://cdn.shopify.com/s/files/1/0651/5985/6347/files/IMG_9305.jpg?v=1761741114',
  ],
  'Réseaux Sociaux — La Machine à Ventes': [
    'https://cdn.shopify.com/s/files/1/0651/5985/6347/files/haut_drop_saint_valentin.jpg?v=1769695650',
    'https://cdn.shopify.com/s/files/1/0651/5985/6347/files/saint_valentin_drop.jpg?v=1769695649',
    'https://cdn.shopify.com/s/files/1/0651/5985/6347/files/drop_st_val.jpg?v=1769695649',
    'https://cdn.shopify.com/s/files/1/0651/5985/6347/files/maillotrivieralagoon.jpg?v=1753709122',
  ],
  'Publicité & Scaling': [
    'https://cdn.shopify.com/s/files/1/0651/5985/6347/files/maillot_de_bain_echancre.jpg?v=1761742066',
    'https://cdn.shopify.com/s/files/1/0651/5985/6347/files/riviera_lagoon.jpg?v=1753709122',
    'https://cdn.shopify.com/s/files/1/0651/5985/6347/files/maillot_offka.jpg?v=1753709122',
    'https://cdn.shopify.com/s/files/1/0651/5985/6347/files/dropstvalentinmatchy.jpg?v=1769702822',
  ],
  // ─── GAUT — NUTRITION & PERFORMANCE ───
  'Les Bases de la Nutrition': [
    'https://images.unsplash.com/photo-1670398564097-0762e1b30b3a?w=800&q=80',
    'https://images.unsplash.com/photo-1598515211932-b130a728a769?w=800&q=80',
    'https://images.unsplash.com/photo-1582983552131-5d59920a9476?w=800&q=80',
    'https://images.unsplash.com/photo-1587996616596-b714c1c54146?w=800&q=80',
  ],
  'Plans Alimentaires Complets': [
    'https://images.unsplash.com/photo-1668838268173-816ee121ad4a?w=800&q=80',
    'https://images.unsplash.com/photo-1666819691716-827f78d892f3?w=800&q=80',
    'https://images.pexels.com/photos/1640771/pexels-photo-1640771.jpeg?auto=compress&w=800',
    'https://images.pexels.com/photos/90893/pexels-photo-90893.jpeg?auto=compress&w=800',
  ],
  'Supplémentation Intelligente': [
    'https://images.unsplash.com/photo-1768161680813-615df885ff82?w=800&q=80',
    'https://images.pexels.com/photos/13779103/pexels-photo-13779103.jpeg?auto=compress&w=800',
    'https://images.pexels.com/photos/15120889/pexels-photo-15120889.jpeg?auto=compress&w=800',
  ],
  'Le Système à Tenir': [
    'https://images.unsplash.com/photo-1758272422576-aed8fde4cc55?w=800&q=80',
    'https://images.unsplash.com/photo-1758272422634-e8ed8e252a14?w=800&q=80',
    'https://images.pexels.com/photos/8425976/pexels-photo-8425976.jpeg?auto=compress&w=800',
    'https://images.unsplash.com/photo-1758521540295-4f219b72d5ab?w=800&q=80',
  ],
};

// Find the section name for a lesson
const getSectionForLesson = (lessonId) => {
  for (const mod of formationModules) {
    for (const sec of mod.sections) {
      if (sec.lessons.some(l => l.id === lessonId)) return sec.title;
    }
  }
  return null;
};

const generateSlides = (lesson, moduleName) => {
  if (!lesson?.script) return [{ type: 'title', title: lesson?.title || 'Leçon', subtitle: moduleName || '', points: [], image: null }];
  const slides = [];
  const lines = lesson.script.split('\n').map(l => l.trim()).filter(Boolean);

  // Get images for this lesson's section
  const sectionName = getSectionForLesson(lesson.id);
  const imagePool = slideImagePools[sectionName] || [];
  let imgIdx = 0;
  const nextImage = () => {
    if (imagePool.length === 0) return null;
    const img = imagePool[imgIdx % imagePool.length];
    imgIdx++;
    return img;
  };

  // Slide 1: Title slide
  const introLines = [];
  let i = 0;
  while (i < lines.length && !lines[i].startsWith('Points') && !lines[i].startsWith('Conclusion') && !lines[i].startsWith('- ')) {
    introLines.push(lines[i]);
    i++;
  }
  slides.push({ type: 'title', title: lesson.title, subtitle: moduleName, points: introLines.length > 0 ? [introLines.join(' ')] : [], image: nextImage() });

  // Collect bullet points
  const bullets = [];
  for (; i < lines.length; i++) {
    const line = lines[i];
    if (line.startsWith('Conclusion')) break;
    if (line.startsWith('Points à aborder')) continue;
    if (line.startsWith('- ')) {
      bullets.push(line.replace(/^- /, ''));
    }
  }

  // Split bullets into slides of 3-4 items each
  const chunkSize = 4;
  for (let c = 0; c < bullets.length; c += chunkSize) {
    const chunk = bullets.slice(c, c + chunkSize);
    slides.push({
      type: 'content',
      title: c === 0 ? 'Points clés' : `Points clés (suite)`,
      points: chunk,
      image: nextImage(),
    });
  }

  // Conclusion slide — extract quote from the Conclusion line itself
  let conclusionText = '';
  for (const line of lines) {
    if (line.startsWith('Conclusion')) {
      conclusionText = line.replace(/^Conclusion\s*:\s*/, '').replace(/^"/, '').replace(/"$/, '');
      break;
    }
  }
  if (conclusionText) {
    slides.push({ type: 'conclusion', title: 'À retenir', points: [conclusionText], image: nextImage() });
  }

  return slides.length > 0 ? slides : [{ type: 'title', title: lesson.title, subtitle: moduleName, points: [], image: null }];
};

// ─── SLIDE VIEWER COMPONENT ───
const SlideViewer = ({ slides, currentSlide, onSlideChange, trainerName, onNextLesson, hasNextLesson, onPrevLesson, hasPrevLesson, lessonIndex, totalLessons }) => {
  const slide = slides[currentSlide] || slides[0];
  const total = slides.length;
  const isLast = currentSlide === total - 1;
  const isFirst = currentSlide === 0;

  return (
    <div className="relative rounded-xl overflow-hidden" style={{ backgroundColor: '#080c15', border: '1px solid rgba(59,130,246,0.12)', aspectRatio: '16/9' }}>
      {/* Background image for all slides */}
      {slide.image && (
        <>
          <img src={slide.image} alt="" className="absolute inset-0 w-full h-full object-cover" style={{ opacity: slide.type === 'title' ? 0.4 : 0.15 }} />
          <div className="absolute inset-0" style={{
            background: slide.type === 'title'
              ? 'linear-gradient(135deg, rgba(8,10,20,0.9) 0%, rgba(8,10,20,0.6) 50%, rgba(8,10,20,0.2) 100%)'
              : 'linear-gradient(to right, rgba(8,10,20,0.96) 0%, rgba(8,10,20,0.93) 55%, rgba(8,10,20,0.4) 100%)',
          }} />
        </>
      )}

      {/* Slide content */}
      <div className="absolute inset-0 flex">
        {slide.type === 'title' && (
          <div className="flex-1 flex flex-col justify-center px-10 py-8">
            <p className="text-[11px] font-bold tracking-[3px] uppercase mb-3" style={{ color: '#60a5fa', fontFamily: '"Inter", sans-serif' }}>{slide.subtitle}</p>
            <h2 className="text-white text-2xl lg:text-3xl font-bold mb-5" style={{ fontFamily: '"Space Grotesk", sans-serif', lineHeight: 1.3 }}>{slide.title}</h2>
            {slide.points.map((p, i) => (
              <p key={i} className="text-gray-300 text-sm leading-relaxed max-w-[65%]" style={{ fontFamily: '"Inter", sans-serif' }}>{p}</p>
            ))}
          </div>
        )}

        {slide.type === 'content' && (
          <div className="flex-1 flex items-stretch">
            <div className="flex-1 flex flex-col justify-center px-10 py-6" style={{ maxWidth: slide.image ? '60%' : '100%' }}>
              <p className="text-[11px] font-bold tracking-[3px] uppercase mb-5" style={{ color: '#60a5fa', fontFamily: '"Inter", sans-serif' }}>{slide.title}</p>
              <div className="space-y-3.5">
                {slide.points.map((p, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <div className="w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5" style={{ backgroundColor: 'rgba(59,130,246,0.12)', border: '1px solid rgba(59,130,246,0.25)' }}>
                      <span className="text-[11px] font-bold" style={{ color: '#60a5fa' }}>{i + 1}</span>
                    </div>
                    <p className="text-gray-200 text-[13px] leading-relaxed" style={{ fontFamily: '"Inter", sans-serif' }}>{p}</p>
                  </div>
                ))}
              </div>
            </div>
            {slide.image && (
              <div className="hidden lg:block w-[35%] relative overflow-hidden">
                <img src={slide.image} alt="" className="absolute inset-0 w-full h-full object-cover" style={{ opacity: 0.9 }} />
                <div className="absolute inset-0" style={{ background: 'linear-gradient(to right, rgba(8,10,20,1) 0%, transparent 30%)' }} />
              </div>
            )}
          </div>
        )}

        {slide.type === 'conclusion' && (
          <div className="flex-1 flex flex-col items-center justify-center px-10 py-8 text-center">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{ backgroundColor: 'rgba(59,130,246,0.12)', border: '1px solid rgba(59,130,246,0.25)' }}>
              <Flame size={22} style={{ color: '#60a5fa' }} />
            </div>
            <p className="text-[11px] font-bold tracking-[3px] uppercase mb-4" style={{ color: '#60a5fa', fontFamily: '"Inter", sans-serif' }}>À retenir</p>
            {slide.points.map((p, i) => (
              <p key={i} className="text-white text-lg lg:text-xl font-semibold leading-relaxed max-w-[70%]" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>
                « {p} »
              </p>
            ))}
          </div>
        )}
      </div>

      {/* Global position indicator */}
      <div className="absolute top-4 right-4 px-3 py-1.5 rounded-lg text-[11px] font-mono flex items-center gap-2" style={{ backgroundColor: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(4px)' }}>
        <span className="text-blue-400 font-bold">Leçon {lessonIndex}/{totalLessons}</span>
        <span className="text-gray-600">·</span>
        <span className="text-gray-400">{currentSlide + 1}/{total}</span>
      </div>

      {/* Navigation arrows — NO dead ends, always clickable */}
      <div className="absolute bottom-4 left-0 right-0 flex items-center justify-between px-4">
        <button
          data-testid="slide-prev"
          onClick={() => {
            if (isFirst && hasPrevLesson && onPrevLesson) {
              onPrevLesson();
            } else {
              onSlideChange(Math.max(0, currentSlide - 1));
            }
          }}
          className={`w-9 h-9 rounded-full flex items-center justify-center transition-all hover:scale-110 ${isFirst && !hasPrevLesson ? 'opacity-20' : ''}`}
          style={{ backgroundColor: 'rgba(0,0,0,0.5)', border: '1px solid rgba(255,255,255,0.15)' }}
        >
          <ChevronLeft size={16} className="text-white" />
        </button>

        {/* Dots */}
        <div className="flex items-center gap-1.5">
          {slides.map((_, idx) => (
            <button
              key={idx}
              onClick={() => onSlideChange(idx)}
              className="transition-all"
              style={{
                width: idx === currentSlide ? 20 : 6,
                height: 6,
                borderRadius: 3,
                backgroundColor: idx === currentSlide ? '#3b82f6' : 'rgba(255,255,255,0.2)',
              }}
            />
          ))}
        </div>

        <button
          data-testid="slide-next"
          onClick={() => {
            if (isLast && hasNextLesson && onNextLesson) {
              onNextLesson();
            } else {
              onSlideChange(Math.min(total - 1, currentSlide + 1));
            }
          }}
          className={`w-9 h-9 rounded-full flex items-center justify-center transition-all hover:scale-110 ${isLast && !hasNextLesson ? 'opacity-20' : ''}`}
          style={{ backgroundColor: 'rgba(0,0,0,0.5)', border: '1px solid rgba(255,255,255,0.15)' }}
        >
          <ChevronRight size={16} className="text-white" />
        </button>
      </div>
    </div>
  );
};

// ─── NOTES PANEL (resizable) ───
const NotesPanel = ({ lessonId, userEmail }) => {
  const [content, setContent] = useState('');
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [height, setHeight] = useState(() => {
    try { return parseInt(localStorage.getItem('notes_panel_height')) || 130; } catch { return 130; }
  });
  const timeoutRef = useRef(null);
  const dragRef = useRef(null);

  useEffect(() => {
    if (!lessonId || !userEmail) return;
    fetch(`${API}/api/notes/${lessonId}`, { headers: { 'x-user-email': userEmail } })
      .then(r => r.json())
      .then(d => setContent(d.content || ''))
      .catch(() => {});
  }, [lessonId, userEmail]);

  const saveNote = useCallback(async (text) => {
    if (!userEmail) return;
    setSaving(true);
    try {
      await fetch(`${API}/api/notes`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'x-user-email': userEmail },
        body: JSON.stringify({ lesson_id: lessonId, content: text })
      });
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
    } catch (e) { console.error(e); }
    setSaving(false);
  }, [lessonId, userEmail]);

  const handleChange = (e) => {
    const text = e.target.value;
    setContent(text);
    setSaved(false);
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => saveNote(text), 1500);
  };

  // Drag to resize
  const startDrag = (e) => {
    e.preventDefault();
    const startY = e.clientY || e.touches?.[0]?.clientY;
    const startH = height;
    const onMove = (ev) => {
      const y = ev.clientY || ev.touches?.[0]?.clientY;
      const newH = Math.max(24, Math.min(300, startH + (y - startY)));
      setHeight(newH);
    };
    const onUp = () => {
      localStorage.setItem('notes_panel_height', String(height));
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp);
      document.removeEventListener('touchmove', onMove);
      document.removeEventListener('touchend', onUp);
    };
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
    document.addEventListener('touchmove', onMove);
    document.addEventListener('touchend', onUp);
  };

  // Save height on change
  useEffect(() => {
    localStorage.setItem('notes_panel_height', String(height));
  }, [height]);

  return (
    <div className="rounded-xl overflow-hidden flex flex-col" style={{ backgroundColor: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.06)' }}>
      <div className="px-4 py-2 flex items-center justify-between" style={{ borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
        <div className="flex items-center gap-2">
          <FileText size={12} style={{ color: '#3b82f6' }} />
          <p className="text-[10px] font-bold tracking-wider" style={{ color: '#3b82f6', fontFamily: '"Inter", sans-serif' }}>MES NOTES</p>
        </div>
        <div className="flex items-center gap-1.5">
          {saving && <span className="text-[10px] text-gray-500">Sauvegarde...</span>}
          {saved && <span className="text-[10px] text-green-400 flex items-center gap-1"><CheckCircle2 size={10} /> Sauvé</span>}
        </div>
      </div>
      <textarea
        data-testid="lesson-notes-textarea"
        value={content}
        onChange={handleChange}
        placeholder="Prends tes notes ici..."
        className="w-full bg-transparent text-gray-300 text-[12px] leading-relaxed px-4 py-2 resize-none focus:outline-none placeholder:text-gray-700"
        style={{ fontFamily: '"Inter", sans-serif', height: `${height}px` }}
      />
      {/* Drag handle */}
      <div
        ref={dragRef}
        onMouseDown={startDrag}
        onTouchStart={startDrag}
        className="h-[6px] cursor-row-resize flex items-center justify-center group"
        style={{ borderTop: '1px solid rgba(255,255,255,0.04)' }}
        title="Glisser pour redimensionner"
      >
        <div className="w-8 h-[3px] rounded-full group-hover:bg-blue-500/40 transition-colors" style={{ backgroundColor: 'rgba(255,255,255,0.1)' }} />
      </div>
    </div>
  );
};

// ─── SECTION IMAGES (musculation) ───
const sectionImages = {
  'Les Fondamentaux de la Musculation': 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=600&q=75',
  'Sécurité et Technique': 'https://images.pexels.com/photos/6339459/pexels-photo-6339459.jpeg?auto=compress&w=600',
  'Les Exercices Fondamentaux': 'https://images.pexels.com/photos/2261477/pexels-photo-2261477.jpeg?auto=compress&w=600',
  'Planification de l\'Entraînement': 'https://images.pexels.com/photos/4164514/pexels-photo-4164514.jpeg?auto=compress&w=600',
  'Nutrition pour la Musculation': 'https://images.pexels.com/photos/1640775/pexels-photo-1640775.jpeg?auto=compress&w=600',
  'La Récupération': 'https://images.pexels.com/photos/4804294/pexels-photo-4804294.jpeg?auto=compress&w=600',
  'Programmes d\'Entraînement Concrets': 'https://images.pexels.com/photos/841130/pexels-photo-841130.jpeg?auto=compress&w=600',
  'Compléments Alimentaires': 'https://images.pexels.com/photos/15120889/pexels-photo-15120889.jpeg?auto=compress&w=600',
  'Suivi et Progression': 'https://images.pexels.com/photos/8155196/pexels-photo-8155196.jpeg?auto=compress&w=600',
  'Plateaux et Motivation': 'https://images.pexels.com/photos/29667299/pexels-photo-29667299.jpeg?auto=compress&w=600',
  'Applications et Outils Recommandés': 'https://images.unsplash.com/photo-1758875568756-37a9c5c1a4f2?w=600&q=75',
  // ─── LISA — E-COMMERCE (OFFKA) ───
  'Mon Parcours & Les Bases': 'https://cdn.shopify.com/s/files/1/0651/5985/6347/files/IMG_9476.jpg?v=1761742066',
  'Créer ta Boutique E-commerce': 'https://cdn.shopify.com/s/files/1/0651/5985/6347/files/IMG_9227.jpg?v=1761739977',
  'Réseaux Sociaux — La Machine à Ventes': 'https://cdn.shopify.com/s/files/1/0651/5985/6347/files/haut_drop_saint_valentin.jpg?v=1769695650',
  'Publicité & Scaling': 'https://cdn.shopify.com/s/files/1/0651/5985/6347/files/riviera_lagoon.jpg?v=1753709122',
  // ─── GAUT — NUTRITION ───
  'Les Bases de la Nutrition': 'https://images.unsplash.com/photo-1670398564097-0762e1b30b3a?w=600&q=75',
  'Plans Alimentaires Complets': 'https://images.pexels.com/photos/1640771/pexels-photo-1640771.jpeg?auto=compress&w=600',
  'Supplémentation Intelligente': 'https://images.unsplash.com/photo-1768161680813-615df885ff82?w=600&q=75',
  'Le Système à Tenir': 'https://images.unsplash.com/photo-1758272422576-aed8fde4cc55?w=600&q=75',
};

// ─── LESSON VIEW (Slides + Notes sidebar) ───
const LessonView = ({ lesson, module, onClose, onComplete, allLessons, onNavigateLesson, userEmail }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const goToLastSlideRef = useRef(false);
  const containerRef = useRef(null);
  const autoCompletedRef = useRef(new Set());

  const slides = lesson ? generateSlides(lesson, module?.title) : [];
  const currentIdx = lesson ? allLessons.findIndex(l => l.id === lesson.id) : -1;
  const prevLesson = currentIdx > 0 ? allLessons[currentIdx - 1] : null;
  const nextLesson = currentIdx < allLessons.length - 1 ? allLessons[currentIdx + 1] : null;
  const trainerName = module?.id ? (trainers[module.id]?.name || 'Formateur') : 'Formateur';

  // Auto-mark lesson complete when reaching the last slide (conclusion)
  useEffect(() => {
    if (!lesson || slides.length === 0) return;
    const isLastSlide = currentSlide === slides.length - 1;
    if (isLastSlide && !lesson.completed && !autoCompletedRef.current.has(lesson.id)) {
      autoCompletedRef.current.add(lesson.id);
      onComplete(lesson.id);
    }
  }, [currentSlide, slides.length, lesson, onComplete]);

  // Navigate to prev lesson and land on its LAST slide
  const goToPrevLesson = useCallback(() => {
    if (prevLesson) {
      goToLastSlideRef.current = true;
      onNavigateLesson(prevLesson.id);
    }
  }, [prevLesson, onNavigateLesson]);

  // Navigate to next lesson (land on first slide)
  const goToNextLesson = useCallback(() => {
    if (nextLesson) {
      goToLastSlideRef.current = false;
      onNavigateLesson(nextLesson.id);
    }
  }, [nextLesson, onNavigateLesson]);

  // Keyboard navigation — seamless flow through all lessons
  useEffect(() => {
    if (!lesson) return;
    const handleKey = (e) => {
      if (e.target.tagName === 'TEXTAREA' || e.target.tagName === 'INPUT') return;
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        if (currentSlide < slides.length - 1) {
          setCurrentSlide(s => s + 1);
        } else {
          goToNextLesson();
        }
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        if (currentSlide > 0) {
          setCurrentSlide(s => s - 1);
        } else {
          goToPrevLesson();
        }
      }
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [lesson, currentSlide, slides.length, goToNextLesson, goToPrevLesson]);

  // Reset slide position when lesson changes
  useEffect(() => {
    if (goToLastSlideRef.current && lesson) {
      // Coming from next lesson via ← : go to last slide
      const newSlides = generateSlides(lesson, module?.title);
      setCurrentSlide(Math.max(0, newSlides.length - 1));
      goToLastSlideRef.current = false;
    } else {
      setCurrentSlide(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lesson?.id]);

  if (!lesson) return null;

  return (
    <div ref={containerRef} tabIndex={-1} className="outline-none">
      {/* Top bar */}
      <div className="flex items-center justify-between mb-4">
        <button onClick={onClose} className="text-gray-500 hover:text-white text-[13px] flex items-center gap-1.5 transition-colors" style={{ fontFamily: '"Inter", sans-serif' }}>
          <ChevronLeft size={16} /> Retour à la formation
        </button>
        <p className="text-gray-600 text-[12px]" style={{ fontFamily: '"Inter", sans-serif' }}>
          Leçon {currentIdx + 1} sur {allLessons.length} · Utilisez ← → pour naviguer
        </p>
      </div>

      <div className="flex flex-col lg:flex-row gap-4">
        {/* LEFT: Content area (68%) */}
        <div className="lg:w-[68%] flex-shrink-0 space-y-3">
          <SlideViewer
            slides={slides}
            currentSlide={currentSlide}
            onSlideChange={(idx) => setCurrentSlide(idx)}
            trainerName={trainerName}
            onNextLesson={goToNextLesson}
            hasNextLesson={!!nextLesson}
            onPrevLesson={goToPrevLesson}
            hasPrevLesson={!!prevLesson}
            lessonIndex={currentIdx + 1}
            totalLessons={allLessons.length}
          />

          {/* Lesson info bar */}
          <div className="rounded-xl px-5 py-3.5 flex items-center justify-between" style={{ backgroundColor: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.06)' }}>
            <div className="flex-1 min-w-0">
              <h2 className="text-white font-bold text-[16px] truncate" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>{lesson.title}</h2>
              <p className="text-gray-500 text-[11px] mt-0.5" style={{ fontFamily: '"Inter", sans-serif' }}>
                {module?.title} · {lesson.duration} · {slides.length} slides
              </p>
            </div>
            <button
              data-testid="video-mark-complete-btn"
              onClick={() => onComplete(lesson.id)}
              className="flex items-center gap-2 px-4 py-2 rounded-lg text-[12px] font-bold transition-all hover:brightness-110 flex-shrink-0"
              style={{
                backgroundColor: lesson.completed ? 'rgba(34,197,94,0.15)' : 'rgba(59,130,246,0.1)',
                color: lesson.completed ? '#22c55e' : '#60a5fa',
                border: `1px solid ${lesson.completed ? 'rgba(34,197,94,0.3)' : 'rgba(59,130,246,0.25)'}`,
                fontFamily: '"Inter", sans-serif',
              }}
            >
              <CheckCircle2 size={14} />
              {lesson.completed ? 'Terminé !' : 'Marquer terminé'}
            </button>
          </div>

          {/* Big navigation CTA */}
          <div className="flex items-center gap-3">
            {prevLesson ? (
              <button
                onClick={goToPrevLesson}
                className="flex items-center gap-2 px-5 py-3 rounded-xl text-[13px] text-gray-400 hover:text-white transition-all flex-1"
                style={{ backgroundColor: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)', fontFamily: '"Inter", sans-serif' }}
              >
                <ChevronLeft size={16} />
                <span className="truncate">Précédent</span>
              </button>
            ) : <div className="flex-1" />}
            {nextLesson ? (
              <button
                data-testid="next-lesson-btn"
                onClick={goToNextLesson}
                className="flex items-center justify-center gap-2.5 px-6 py-3.5 rounded-xl text-[14px] font-bold transition-all hover:brightness-110 flex-[2]"
                style={{ backgroundColor: '#3b82f6', color: '#ffffff', fontFamily: '"Space Grotesk", sans-serif' }}
              >
                Leçon suivante <ArrowRight size={18} />
              </button>
            ) : (
              <div className="flex items-center justify-center gap-2 px-6 py-3.5 rounded-xl text-[14px] font-bold flex-[2]"
                style={{ backgroundColor: 'rgba(34,197,94,0.15)', color: '#22c55e', border: '1px solid rgba(34,197,94,0.2)', fontFamily: '"Space Grotesk", sans-serif' }}
              >
                <CheckCircle2 size={18} /> Dernière leçon de la formation
              </div>
            )}
          </div>
        </div>

        {/* RIGHT: Notes + Lesson list (32%) — always visible */}
        <div className="lg:w-[32%] flex-1 space-y-3">
          {/* Notes - compact */}
          <NotesPanel lessonId={lesson.id} userEmail={userEmail} />

          {/* Lesson list */}
          <div className="rounded-xl overflow-hidden" style={{ backgroundColor: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.06)' }}>
            <div className="px-4 py-2.5" style={{ borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
              <p className="text-[11px] font-bold tracking-wider text-gray-500" style={{ fontFamily: '"Inter", sans-serif' }}>
                CONTENU · {allLessons.filter(l => l.completed).length}/{allLessons.length} terminés
              </p>
            </div>
            <div className="max-h-[400px] overflow-y-auto">
              {allLessons.map((l) => (
                <div
                  key={l.id}
                  onClick={() => onNavigateLesson(l.id)}
                  className={`flex items-center gap-2.5 px-4 py-2.5 cursor-pointer transition-colors text-[12px] ${l.id === lesson.id ? 'bg-white/[0.06]' : 'hover:bg-white/[0.03]'}`}
                  style={{ fontFamily: '"Inter", sans-serif' }}
                >
                  <div className="w-[20px] h-[20px] rounded-full flex items-center justify-center flex-shrink-0"
                    style={{
                      backgroundColor: l.id === lesson.id ? 'rgba(59,130,246,0.2)' : l.completed ? 'rgba(34,197,94,0.15)' : 'rgba(255,255,255,0.05)',
                      border: l.id === lesson.id ? '2px solid #3b82f6' : 'none',
                    }}>
                    {l.completed ? <CheckCircle2 size={10} style={{ color: '#22c55e' }} /> : <Play size={8} style={{ color: l.id === lesson.id ? '#3b82f6' : '#555' }} className="ml-0.5" />}
                  </div>
                  <span className={`truncate flex-1 ${l.id === lesson.id ? 'text-white font-medium' : l.completed ? 'text-gray-600' : 'text-gray-400'}`}>{l.title}</span>
                  <span className="text-gray-600 font-mono flex-shrink-0 text-[10px]">{l.duration}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Sidebar = ({ user, onLogout, activeTab, setActiveTab }) => {
  const t = useT();
  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: Home },
    { id: 'programmes', label: t.dashboard.programmes, icon: GraduationCap },
    { id: 'monk-mode', label: t.dashboard.monkMode, icon: Flame },
    { id: 'ressources', label: t.dashboard.resources, icon: Bookmark },
    { id: 'communaute', label: t.dashboard.community, icon: Users, href: TELEGRAM_URL },
    { id: 'recordings', label: t.dashboard.recordings, icon: PlayCircle, badge: 'lock' },
    { id: 'support', label: t.dashboard.support, icon: HelpCircle },
    { id: 'affiliate', label: t.dashboard.affiliate, icon: Share2 },
    { id: 'parametres', label: t.dashboard.settings, icon: Settings },
  ];

  return (
    <aside className="w-[220px] min-h-screen flex-shrink-0 flex flex-col" data-testid="dashboard-sidebar" style={{ backgroundColor: '#0d1120' }}>
      {/* Logo */}
      <div className="px-5 pt-5 pb-2">
        <h1 className="text-[22px] font-black tracking-tight" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>
          <span style={{ color: '#60a5fa' }}>OPEN</span><span style={{ color: '#ffffff' }}>ROOM</span>
        </h1>
      </div>

      {/* User */}
      <div className="px-5 py-4 flex flex-col items-center">
        <div className="w-[80px] h-[80px] rounded-full overflow-hidden mb-3" style={{ border: '2px solid rgba(59, 130, 246, 0.4)' }}>
          <div className="w-full h-full bg-gradient-to-br from-[#1B2A4A] to-[#2d4a7a] flex items-center justify-center">
            <span className="text-white text-[28px] font-bold" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>
              {user?.name?.[0]?.toUpperCase() || 'O'}
            </span>
          </div>
        </div>
        <p className="text-white text-center text-[14px] font-bold" data-testid="sidebar-user-name" style={{ fontFamily: '"Inter", sans-serif' }}>
          {user?.name || 'Membre'}
        </p>
        <p className="text-gray-500 text-center text-[12px] mt-0.5" style={{ fontFamily: '"Inter", sans-serif' }}>
          {user?.email || ''}
        </p>
      </div>

      {/* Separator */}
      <div className="mx-4 h-[1px]" style={{ backgroundColor: 'rgba(255,255,255,0.06)' }} />

      {/* Nav */}
      <nav className="flex-1 py-3 px-3">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = activeTab === item.id;

          if (item.href) {
            return (
              <a
                key={item.id}
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`sidebar-${item.id}`}
                className="w-full flex items-center gap-3 px-3 py-2 rounded-md mb-0.5 transition-all duration-200 text-left text-gray-500 hover:text-gray-300 no-underline"
                style={{ fontFamily: '"Inter", sans-serif' }}
              >
                <Icon size={16} />
                <span className="text-[13px] flex-1">{item.label}</span>
                <ExternalLink size={12} className="text-gray-600" />
              </a>
            );
          }

          return (
            <button
              key={item.id}
              data-testid={`sidebar-${item.id}`}
              onClick={() => {
                if (item.badge === 'lock') return;
                setActiveTab(item.id);
              }}
              className={`w-full flex items-center gap-3 px-3 py-2 rounded-md mb-0.5 transition-all duration-200 text-left ${
                isActive ? 'text-white' : 'text-gray-500 hover:text-gray-300'
              } ${item.badge === 'lock' ? 'opacity-50' : ''}`}
              style={{
                backgroundColor: isActive ? 'rgba(59, 130, 246, 0.08)' : 'transparent',
                fontFamily: '"Inter", sans-serif',
              }}
            >
              <Icon size={16} style={{ color: isActive ? '#3b82f6' : undefined }} />
              <span className="text-[13px] flex-1">{item.label}</span>
              {item.badge === 'lock' && <Lock size={12} className="text-gray-600" />}
            </button>
          );
        })}
      </nav>

      {/* Logout */}
      <div className="px-3 pb-5 space-y-1">
        <button
          onClick={onLogout}
          data-testid="sidebar-logout"
          className="w-full flex items-center gap-3 px-3 py-2 rounded-md text-gray-600 hover:text-red-400 transition-all duration-200"
          style={{ fontFamily: '"Inter", sans-serif' }}
        >
          <LogOut size={16} />
          <span className="text-[13px]">{t.dashboard.logout}</span>
        </button>
      </div>
    </aside>
  );
};

/* ─── LIVE CLOCK + MINI CALENDAR ─── */
const LiveClockCalendar = () => {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const dayNames = ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'];
  const monthNames = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
  const today = now.getDate();
  const month = now.getMonth();
  const year = now.getFullYear();
  const dayOfWeek = dayNames[now.getDay()];
  const monthName = monthNames[month];
  const hours = String(now.getHours()).padStart(2, '0');
  const mins = String(now.getMinutes()).padStart(2, '0');
  const secs = String(now.getSeconds()).padStart(2, '0');

  const firstDay = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const calDays = [];
  for (let i = 0; i < firstDay; i++) calDays.push(null);
  for (let d = 1; d <= daysInMonth; d++) calDays.push(d);

  return (
    <div data-testid="live-clock-calendar" className="rounded-2xl overflow-hidden" style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)', backdropFilter: 'blur(16px)' }}>
      <div className="p-4">
        {/* Date + Time */}
        <div className="flex items-center justify-between mb-3">
          <div>
            <p className="text-white text-[14px] font-bold" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>
              {dayOfWeek} {today} {monthName}
            </p>
            <p className="text-gray-500 text-[10px]" style={{ fontFamily: '"Inter", sans-serif' }}>{monthName} {year}</p>
          </div>
          <div className="text-right">
            <p className="text-[22px] font-bold text-white tabular-nums" style={{ fontFamily: '"Space Grotesk", sans-serif', letterSpacing: '0.5px' }}>
              {hours}<span className="text-[#3b82f6]">:</span>{mins}<span className="text-gray-500 text-[16px]">:{secs}</span>
            </p>
          </div>
        </div>
        {/* Mini calendar grid */}
        <div className="grid grid-cols-7 gap-px">
          {dayNames.map(d => (
            <div key={d} className="text-center text-[8px] text-gray-600 pb-1" style={{ fontFamily: '"Inter", sans-serif' }}>{d[0]}</div>
          ))}
          {calDays.map((d, i) => (
            <div key={i} className="flex items-center justify-center h-[20px]">
              {d && (
                <span className="w-[18px] h-[18px] flex items-center justify-center rounded-full text-[9px] font-medium"
                  style={{
                    backgroundColor: d === today ? '#3b82f6' : 'transparent',
                    color: d === today ? '#fff' : d < today ? 'rgba(255,255,255,0.25)' : 'rgba(255,255,255,0.5)',
                    fontFamily: '"Inter", sans-serif',
                  }}>
                  {d}
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

/* ─── DAILY HABITS WIDGET ─── */
const DailyHabits = ({ user }) => {
  const [habits, setHabits] = useState([]);
  const [streak, setStreak] = useState(0);
  const [newHabit, setNewHabit] = useState('');
  const [adding, setAdding] = useState(false);

  const fetchHabits = useCallback(async () => {
    try {
      const res = await fetch(`${API}/api/habits`, { headers: getAuthHeaders() });
      if (res.ok) {
        const data = await res.json();
        setHabits(data.habits || []);
        setStreak(data.streak || 0);
      }
    } catch {}
  }, []);

  useEffect(() => { fetchHabits(); }, [fetchHabits]);

  const toggleHabit = async (habitId) => {
    setHabits(prev => prev.map(h => h.habit_id === habitId ? { ...h, completed: !h.completed } : h));
    try {
      await fetch(`${API}/api/habits/toggle`, {
        method: 'POST',
        headers: getAuthHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify({ habit_id: habitId }),
      });
      fetchHabits();
    } catch {}
  };

  const addHabit = async () => {
    if (!newHabit.trim()) return;
    try {
      await fetch(`${API}/api/habits`, {
        method: 'POST',
        headers: getAuthHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify({ label: newHabit.trim() }),
      });
      setNewHabit('');
      setAdding(false);
      fetchHabits();
    } catch {}
  };

  const deleteHabit = async (habitId) => {
    try {
      await fetch(`${API}/api/habits/${habitId}`, { method: 'DELETE', headers: getAuthHeaders() });
      fetchHabits();
    } catch {}
  };

  const completedCount = habits.filter(h => h.completed).length;
  const totalCount = habits.length;
  const pct = totalCount > 0 ? Math.round((completedCount / totalCount) * 100) : 0;

  return (
    <div data-testid="daily-habits-widget" className="rounded-2xl overflow-hidden" style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)', backdropFilter: 'blur(16px)' }}>
      <div className="p-5">
        {/* Header */}
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2.5">
            <div className="w-[34px] h-[34px] rounded-lg flex items-center justify-center" style={{ backgroundColor: 'rgba(59,130,246,0.1)' }}>
              <Target size={16} style={{ color: '#3b82f6' }} />
            </div>
            <div>
              <h3 className="text-white font-bold text-[14px]" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>Habitudes du jour</h3>
              <p className="text-gray-600 text-[10px]" style={{ fontFamily: '"Inter", sans-serif' }}>{completedCount}/{totalCount} complétées</p>
            </div>
          </div>
          {streak > 0 && (
            <div className="flex items-center gap-1.5 px-2.5 py-1 rounded-lg" style={{ backgroundColor: 'rgba(251,146,60,0.1)', border: '1px solid rgba(251,146,60,0.15)' }}>
              <Zap size={12} style={{ color: '#fb923c' }} />
              <span className="text-[11px] font-bold" style={{ color: '#fb923c', fontFamily: '"Inter", sans-serif' }}>{streak}j</span>
            </div>
          )}
        </div>

        {/* Progress bar */}
        <div className="w-full h-1.5 rounded-full mb-4" style={{ backgroundColor: 'rgba(255,255,255,0.06)' }}>
          <div className="h-full rounded-full transition-all duration-500" style={{ width: `${pct}%`, backgroundColor: pct === 100 ? '#22c55e' : '#3b82f6' }} />
        </div>

        {/* Habits list */}
        <div className="space-y-1">
          {habits.map((habit) => (
            <div
              key={habit.habit_id}
              className="flex items-center gap-3 p-2.5 rounded-xl group hover:bg-white/[0.03] transition-colors cursor-pointer"
              onClick={() => toggleHabit(habit.habit_id)}
            >
              <div
                className="w-[22px] h-[22px] rounded-md flex items-center justify-center flex-shrink-0 transition-all"
                style={{
                  backgroundColor: habit.completed ? 'rgba(34,197,94,0.15)' : 'transparent',
                  border: habit.completed ? '1.5px solid #22c55e' : '1.5px solid rgba(255,255,255,0.12)',
                }}
              >
                {habit.completed && <CheckCircle2 size={13} style={{ color: '#22c55e' }} />}
              </div>
              <span className={`text-[13px] flex-1 transition-colors ${habit.completed ? 'text-gray-600 line-through' : 'text-gray-300'}`} style={{ fontFamily: '"Inter", sans-serif' }}>
                {habit.label}
              </span>
              <button
                onClick={(e) => { e.stopPropagation(); deleteHabit(habit.habit_id); }}
                className="opacity-0 group-hover:opacity-100 transition-opacity p-1 rounded hover:bg-white/[0.05]"
              >
                <Trash2 size={12} className="text-gray-600" />
              </button>
            </div>
          ))}
        </div>

        {/* Add habit */}
        {adding ? (
          <div className="flex items-center gap-2 mt-3">
            <input
              type="text"
              value={newHabit}
              onChange={(e) => setNewHabit(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && addHabit()}
              placeholder="Nouvelle habitude..."
              autoFocus
              className="flex-1 bg-transparent text-[13px] text-white px-3 py-2 rounded-lg outline-none"
              style={{ border: '1px solid rgba(255,255,255,0.1)', fontFamily: '"Inter", sans-serif' }}
            />
            <button onClick={addHabit} className="px-3 py-2 rounded-lg text-[12px] font-bold" style={{ backgroundColor: '#3b82f6', color: '#fff' }}>OK</button>
            <button onClick={() => { setAdding(false); setNewHabit(''); }} className="px-2 py-2 rounded-lg text-gray-500 hover:text-white"><X size={14} /></button>
          </div>
        ) : (
          <button
            data-testid="add-habit-btn"
            onClick={() => setAdding(true)}
            className="flex items-center gap-1.5 mt-3 text-[12px] text-gray-500 hover:text-gray-300 transition-colors"
            style={{ fontFamily: '"Inter", sans-serif' }}
          >
            <Plus size={13} /> Ajouter une habitude
          </button>
        )}
      </div>
    </div>
  );
};

/* ─── TRAINER CALL PICKER ─── */
const TrainerCallPicker = ({ user }) => {
  const allTrainers = [
    { id: 'musculation', ...trainers.musculation },
    { id: 'reseaux', ...trainers.reseaux },
    { id: 'montage', ...trainers.montage },
    { id: 'filming', ...trainers.filming },
    { id: 'ia', ...trainers.ia },
    { id: 'nutrition', ...trainers.nutrition },
    { id: 'monkmode', ...trainers.monkmode },
  ];

  const [booking, setBooking] = useState(false);
  const [booked, setBooked] = useState(null);

  useEffect(() => {
    if (user?.email) {
      fetch(`${API}/api/call/status?email=${encodeURIComponent(user.email)}`, { headers: getAuthHeaders() })
        .then(r => r.json()).then(d => { if (d?.has_recent_booking) setBooked(d); }).catch(() => {});
    }
  }, [user?.email]);

  const handleBook = async (trainer) => {
    if (!user?.email) return;
    setBooking(true);
    try {
      const res = await fetch(`${API}/api/call/book`, {
        method: 'POST',
        headers: getAuthHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify({ email: user.email, module_id: trainer.id, trainer_name: trainer.name }),
      });
      if (res.ok) {
        window.open(trainer.calendly, '_blank');
        setBooked({ has_recent_booking: true });
      } else {
        const err = await res.json();
        alert(err.detail || 'Erreur');
      }
    } catch { alert('Erreur de connexion'); }
    setBooking(false);
  };

  return (
    <div data-testid="trainer-call-picker" className="rounded-2xl overflow-hidden" style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)', backdropFilter: 'blur(16px)' }}>
      <div className="p-5">
        <div className="flex items-center gap-2.5 mb-4">
          <div className="w-[34px] h-[34px] rounded-lg flex items-center justify-center" style={{ backgroundColor: 'rgba(59,130,246,0.1)' }}>
            <Phone size={16} style={{ color: '#3b82f6' }} />
          </div>
          <div>
            <h3 className="text-white font-bold text-[14px]" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>Réserver un call</h3>
            <p className="text-gray-600 text-[10px]" style={{ fontFamily: '"Inter", sans-serif' }}>1 call / mois inclus</p>
          </div>
        </div>

        {booked ? (
          <div className="flex items-center gap-2 px-4 py-3 rounded-xl" style={{ backgroundColor: 'rgba(34,197,94,0.08)', border: '1px solid rgba(34,197,94,0.15)' }}>
            <CheckCircle2 size={15} style={{ color: '#22c55e' }} />
            <span className="text-[12px]" style={{ color: '#22c55e', fontFamily: '"Inter", sans-serif' }}>Call réservé ce mois-ci</span>
          </div>
        ) : (
          <div className="space-y-1.5">
            {allTrainers.map((t) => (
              <div
                key={t.id}
                data-testid={`trainer-${t.id}`}
                onClick={() => !booking && handleBook(t)}
                className="flex items-center gap-3 p-2.5 rounded-xl hover:bg-white/[0.04] cursor-pointer transition-colors group"
              >
                <div className="w-[30px] h-[30px] rounded-full flex items-center justify-center text-[11px] font-bold" style={{ backgroundColor: 'rgba(59,130,246,0.1)', color: '#3b82f6', fontFamily: '"Space Grotesk", sans-serif' }}>
                  {t.name[0]}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-gray-300 text-[12px] font-medium truncate group-hover:text-white transition-colors" style={{ fontFamily: '"Inter", sans-serif' }}>{t.name}</p>
                  <p className="text-gray-600 text-[10px] truncate" style={{ fontFamily: '"Inter", sans-serif' }}>{t.role}</p>
                </div>
                <Calendar size={13} className="text-gray-600 opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

/* ─── DASHBOARD HOME ─── */
const DashboardHome = ({ user, onNavigateFormation, onNavigateProgrammes }) => {
  const t = useT();

  // Calculate overall progress across all formations and find the next lesson to continue
  const totalAllLessons = formationModules.reduce((acc, mod) => acc + mod.sections.reduce((a, s) => a + s.lessons.length, 0), 0);
  let totalCompleted = 0;
  let continueInfo = null; // {moduleId, lessonTitle, moduleTitle, moduleSubtitle}

  formationModules.forEach(mod => {
    try {
      const prog = JSON.parse(localStorage.getItem(`progress_${mod.id}`) || '[]');
      totalCompleted += prog.length;
      // Find the first uncompleted lesson in this module (for "Continuer" button)
      if (!continueInfo && prog.length > 0) {
        for (const section of mod.sections) {
          const next = section.lessons.find(l => !prog.includes(l.id));
          if (next) {
            continueInfo = { moduleId: mod.id, lessonTitle: next.title, moduleTitle: mod.title, moduleSubtitle: mod.subtitle };
            break;
          }
        }
        // If all lessons in this module are done, still note it
        if (!continueInfo) {
          continueInfo = { moduleId: mod.id, lessonTitle: null, moduleTitle: mod.title, moduleSubtitle: mod.subtitle, allDone: true };
        }
      }
    } catch {}
  });

  // If no progress anywhere, default to first module
  if (!continueInfo) {
    const firstMod = formationModules[0];
    if (firstMod) {
      const firstLesson = firstMod.sections[0]?.lessons[0];
      continueInfo = { moduleId: firstMod.id, lessonTitle: firstLesson?.title || '', moduleTitle: firstMod.title, moduleSubtitle: firstMod.subtitle };
    }
  }

  const hasStarted = totalCompleted > 0;
  const overallPct = totalAllLessons > 0 ? Math.round((totalCompleted / totalAllLessons) * 100) : 0;

  return (
    <div>
      <h1 className="text-[26px] font-bold mb-0.5" style={{ fontFamily: '"Space Grotesk", sans-serif', color: '#FFFFFF' }}>
        Dashboard
      </h1>
      <p className="text-gray-500 text-[14px] mb-6" style={{ fontFamily: '"Inter", sans-serif' }}>
        {t.dashboard.welcome}, {user?.name?.split(' ')[0] || 'Membre'} !
      </p>

      {/* Separator */}
      <div className="h-[1px] mb-6" style={{ backgroundColor: 'rgba(255,255,255,0.06)' }} />

      {/* Top Row: Banner + Clock/Calendar */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 mb-5">
        {/* What's New Banner */}
        <div className="lg:col-span-2 rounded-2xl overflow-hidden" style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)', backdropFilter: 'blur(16px)' }}>
          <div className="relative overflow-hidden rounded-2xl" style={{ background: 'linear-gradient(135deg, #0a1025 0%, #101830 30%, #0a0e17 100%)' }}>
            <div className="absolute inset-0" style={{ background: 'radial-gradient(ellipse at 60% 50%, rgba(59,130,246,0.12), transparent 70%)' }} />
            <div className="relative z-10 p-8 flex flex-col items-center justify-center min-h-[160px] text-center">
              <h2 className="text-[32px] lg:text-[40px] font-black leading-[0.95] mb-4" style={{ fontFamily: '"Space Grotesk", sans-serif', color: '#FFFFFF' }}>
                OPEN<br />ROOM<span className="text-[#3b82f6]">&#10022;</span>
              </h2>
              <button
                onClick={onNavigateProgrammes}
                className="px-8 py-2.5 bg-white text-black font-bold text-[13px] tracking-wider rounded-sm hover:bg-gray-100 transition-all"
                style={{ fontFamily: '"Inter", sans-serif' }}
              >
                {hasStarted ? 'CONTINUER' : 'COMMENCER'}
              </button>
            </div>
          </div>
        </div>

        {/* Clock + Calendar (top right) */}
        <LiveClockCalendar />
      </div>

      {/* Main Content: 3 columns */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">

        {/* Column 1: Continue Learning + Community */}
        <div className="space-y-5">
          {/* Continue card */}
          <div className="rounded-2xl overflow-hidden" style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)', backdropFilter: 'blur(16px)' }}>
            <div className="p-4 pb-2">
              <p className="text-gray-500 text-[11px] font-medium mb-3" style={{ fontFamily: '"Inter", sans-serif' }}>Ta formation</p>
            </div>
            <div
              className="mx-3 mb-3 rounded-xl overflow-hidden cursor-pointer group relative"
              onClick={() => onNavigateFormation(continueInfo?.moduleId || 'musculation')}
            >
              <div className="h-[140px] relative" style={{ background: 'linear-gradient(135deg, rgba(59,130,246,0.15) 0%, rgba(10,14,30,0.8) 50%, #0a0e17 100%)' }}>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-[44px] h-[44px] rounded-full bg-white/10 flex items-center justify-center group-hover:bg-white/20 transition-all backdrop-blur-sm border border-white/20">
                    <Play size={18} className="text-white ml-0.5" />
                  </div>
                </div>
                <div className="absolute top-2.5 left-2.5">
                  <span className="px-2.5 py-1 rounded-full text-[10px] font-bold" style={{ backgroundColor: '#3b82f6', color: '#fff', fontFamily: '"Inter", sans-serif' }}>
                    {hasStarted ? 'Continuer' : 'Commencer'}
                  </span>
                </div>
              </div>
              <div className="p-3" style={{ backgroundColor: 'rgba(0,0,0,0.2)' }}>
                <h4 className="text-white font-bold text-[13px]" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>
                  {continueInfo?.lessonTitle || continueInfo?.moduleTitle || 'Bienvenue — Le Mindset du Guerrier'}
                </h4>
                <p className="text-gray-500 text-[11px] mt-0.5" style={{ fontFamily: '"Inter", sans-serif' }}>
                  {continueInfo?.moduleSubtitle || 'Musculation & Discipline'}
                </p>
              </div>
            </div>
          </div>

          {/* Community */}
          <a href={TELEGRAM_URL} target="_blank" rel="noopener noreferrer" data-testid="community-telegram-card" className="block rounded-2xl overflow-hidden cursor-pointer relative no-underline" style={{ background: 'linear-gradient(135deg, #7f1d1d 0%, #b91c1c 50%, #991b1b 100%)' }}>
            <div className="absolute inset-0 opacity-20" style={{ background: 'radial-gradient(circle at 80% 60%, rgba(255,255,255,0.3), transparent 60%)' }} />
            <div className="relative z-10 p-6 flex flex-col items-center justify-center min-h-[100px] text-center">
              <h3 className="text-[20px] font-black leading-[1] mb-3" style={{ fontFamily: '"Space Grotesk", sans-serif', color: '#FFFFFF' }}>
                REJOINS LA COMMUNAUTÉ
              </h3>
              <span className="px-6 py-2 bg-white text-black font-bold text-[11px] tracking-wider rounded-sm hover:bg-gray-100 transition-all inline-block" style={{ fontFamily: '"Inter", sans-serif' }}>ACCÉDER</span>
            </div>
          </a>
        </div>

        {/* Column 2: Daily Habits */}
        <DailyHabits user={user} />

        {/* Column 3: Call Picker */}
        <TrainerCallPicker user={user} />

      </div>
    </div>
  );
};

/* ─── PROGRAMS LIST ─── */
const ProgramsList = ({ onNavigateFormation }) => {
  const campusImages = {
    musculation: 'https://customer-assets.emergentagent.com/job_634756e7-d357-4658-b587-893379df9990/artifacts/38gaug6t_Upscaled%20Image%20%287%29.png',
    reseaux: 'https://customer-assets.emergentagent.com/job_3c0de952-2f29-471c-a2e0-4fa7608f4c1b/artifacts/1sses6ae_Upscaled%20Image%20%286%29.png',
    montage: 'https://customer-assets.emergentagent.com/job_3c0de952-2f29-471c-a2e0-4fa7608f4c1b/artifacts/4b1wj2x4_Upscaled%20Image%20%282%29.png',
    ia: 'https://customer-assets.emergentagent.com/job_3c0de952-2f29-471c-a2e0-4fa7608f4c1b/artifacts/5m8ob6w8_Upscaled%20Image%20%285%29.png',
    nutrition: 'https://customer-assets.emergentagent.com/job_3c0de952-2f29-471c-a2e0-4fa7608f4c1b/artifacts/oyz55eql_Upscaled%20Image%20%284%29.png',
    filming: 'https://customer-assets.emergentagent.com/job_3c0de952-2f29-471c-a2e0-4fa7608f4c1b/artifacts/i27uci5a_Upscaled%20Image%20%283%29.png',
  };

  return (
    <div className="h-full flex flex-col">
      <div className="flex items-center justify-between mb-3 flex-shrink-0">
        <div>
          <h1 className="text-[22px] font-bold" style={{ fontFamily: '"Space Grotesk", sans-serif', color: '#FFFFFF' }}>Programmes</h1>
          <p className="text-gray-500 text-[12px]" style={{ fontFamily: '"Inter", sans-serif' }}>Accède à toutes tes formations</p>
        </div>
      </div>

      <div className="flex-1 grid grid-cols-2 lg:grid-cols-3 grid-rows-2 gap-3">
        {formationModules.map((mod) => {
          const Icon = iconMap[mod.icon] || BookOpen;
          const totalLessons = mod.sections.reduce((acc, s) => acc + s.lessons.length, 0);
          let completedCount = 0;
          try { completedCount = JSON.parse(localStorage.getItem(`progress_${mod.id}`) || '[]').length; } catch {}
          const pct = totalLessons > 0 ? Math.round((completedCount / totalLessons) * 100) : 0;
          const bgImage = campusImages[mod.id];
          const allDone = pct === 100;

          return (
            <div
              key={mod.id}
              data-testid={`campus-card-${mod.id}`}
              className="rounded-2xl overflow-hidden cursor-pointer group transition-all duration-300 hover:scale-[1.01] relative"
              style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)', backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)' }}
              onClick={() => onNavigateFormation(mod.id)}
            >
              {/* Full card background image */}
              {bgImage && <img src={bgImage} alt={mod.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />}
              <div className="absolute inset-0" style={{ background: 'linear-gradient(to top, rgba(5,8,18,0.97) 0%, rgba(5,8,18,0.6) 40%, rgba(5,8,18,0.2) 70%, rgba(5,8,18,0.15) 100%)' }} />

              {/* Icon badge top-left */}
              <div className="absolute top-3 left-3 w-[30px] h-[30px] rounded-lg flex items-center justify-center z-10"
                style={{ backgroundColor: 'rgba(0,0,0,0.4)', backdropFilter: 'blur(8px)', border: '1px solid rgba(255,255,255,0.1)' }}>
                <Icon size={14} style={{ color: '#fff' }} />
              </div>

              {/* Progress circle top-right */}
              {pct > 0 && (
                <div className="absolute top-3 right-3 z-10">
                  <svg width="30" height="30" viewBox="0 0 30 30" className="transform -rotate-90">
                    <circle cx="15" cy="15" r="12" fill="rgba(0,0,0,0.5)" stroke="rgba(255,255,255,0.1)" strokeWidth="2" />
                    <circle cx="15" cy="15" r="12" fill="none" stroke={allDone ? '#22c55e' : '#3b82f6'} strokeWidth="2" strokeLinecap="round"
                      strokeDasharray={`${pct * 0.754} 75.4`} />
                  </svg>
                  <span className="absolute inset-0 flex items-center justify-center text-[8px] font-bold text-white">{pct}%</span>
                </div>
              )}

              {/* Bottom content */}
              <div className="absolute bottom-0 left-0 right-0 p-4 z-10">
                <h3 className="text-white font-bold text-[15px] leading-tight mb-1" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>
                  {mod.title}
                </h3>
                <p className="text-gray-400 text-[11px] mb-2.5" style={{ fontFamily: '"Inter", sans-serif' }}>{mod.subtitle}</p>
                <div className="flex items-center justify-between">
                  <span className="text-gray-500 text-[10px]" style={{ fontFamily: '"Inter", sans-serif' }}>
                    {totalLessons} leçons · {mod.sections.length} sections
                  </span>
                  <ArrowRight size={13} className="text-gray-500 group-hover:text-white transition-colors" />
                </div>
                {/* Progress bar */}
                <div className="mt-2 h-1 rounded-full" style={{ backgroundColor: 'rgba(255,255,255,0.08)' }}>
                  <div className="h-full rounded-full transition-all duration-500" style={{ width: `${pct}%`, backgroundColor: allDone ? '#22c55e' : '#3b82f6' }} />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

// ─── SCRIPT INFO MODAL ───
const ScriptModal = ({ lesson, onClose }) => {
  if (!lesson) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center" style={{ backgroundColor: 'rgba(0,0,0,0.85)' }}>
      <div className="relative w-full max-w-2xl mx-4 max-h-[80vh] flex flex-col rounded-xl overflow-hidden" style={{ backgroundColor: '#151920', border: '1px solid rgba(255,255,255,0.1)' }}>
        <div className="flex items-center justify-between px-6 py-4 flex-shrink-0" style={{ borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
          <div>
            <p className="text-[11px] font-bold tracking-wider mb-1" style={{ color: '#3b82f6', fontFamily: '"Inter", sans-serif' }}>SCRIPT VIDÉO</p>
            <h3 className="text-white font-bold text-[16px]" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>{lesson.title}</h3>
          </div>
          <button onClick={onClose} className="p-2 text-gray-400 hover:text-white transition-colors" data-testid="script-modal-close">
            <X size={20} />
          </button>
        </div>
        <div className="overflow-y-auto flex-1 px-6 py-5">
          <div className="text-gray-300 text-[14px] leading-[1.8] whitespace-pre-wrap" style={{ fontFamily: '"Inter", sans-serif' }}>
            {lesson.script}
          </div>
        </div>
        <div className="px-6 py-3 flex-shrink-0 text-center" style={{ borderTop: '1px solid rgba(255,255,255,0.06)', backgroundColor: 'rgba(59,130,246,0.03)' }}>
          <p className="text-[11px]" style={{ color: 'rgba(59,130,246,0.5)', fontFamily: '"Inter", sans-serif' }}>Ce script est un guide pour Lisa — il sera retiré après le tournage</p>
        </div>
      </div>
    </div>
  );
};

// ─── CALL BOOKING WIDGET ───
const CallBookingWidget = ({ moduleId, user }) => {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showCalendly, setShowCalendly] = useState(false);
  const [booking, setBooking] = useState(false);
  const trainer = trainers[moduleId];

  useEffect(() => {
    if (user?.email) {
      fetch(`${API}/api/call/status?email=${encodeURIComponent(user.email)}`)
        .then(r => r.json()).then(setStatus).catch(() => {}).finally(() => setLoading(false));
    } else { setLoading(false); }
  }, [user?.email]);

  const handleBook = async () => {
    if (!user?.email || !trainer) return;
    setBooking(true);
    try {
      const res = await fetch(`${API}/api/call/book`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: user.email, module_id: moduleId, trainer_name: trainer.name }),
      });
      if (!res.ok) {
        const err = await res.json();
        alert(err.detail || 'Erreur');
        setBooking(false);
        return;
      }
      // Open Calendly link
      window.open(trainer.calendly, '_blank');
      // Refresh status
      const updated = await fetch(`${API}/api/call/status?email=${encodeURIComponent(user.email)}`).then(r => r.json());
      setStatus(updated);
    } catch { alert('Erreur de connexion'); }
    setBooking(false);
  };

  if (loading) return null;
  if (!trainer) return null;

  const hasBooked = status?.has_recent_booking;

  return (
    <div className="rounded-2xl overflow-hidden" style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)', backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)' }}>
      <div className="p-5">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-[40px] h-[40px] rounded-full flex items-center justify-center" style={{ backgroundColor: 'rgba(59,130,246,0.1)', border: '1px solid rgba(59,130,246,0.15)' }}>
            <Phone size={18} style={{ color: '#3b82f6' }} />
          </div>
          <div>
            <h3 className="text-white font-bold text-[14px]" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>Réserver un call privé</h3>
            <p className="text-gray-500 text-[11px]" style={{ fontFamily: '"Inter", sans-serif' }}>1 call / mois inclus dans ton abonnement</p>
          </div>
        </div>

        <div className="rounded-lg p-4 mb-3" style={{ backgroundColor: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.04)' }}>
          <div className="flex items-center gap-3">
            <div className="w-[36px] h-[36px] rounded-full flex items-center justify-center text-[13px] font-bold" style={{ backgroundColor: 'rgba(59,130,246,0.12)', color: '#3b82f6', fontFamily: '"Space Grotesk", sans-serif' }}>
              ?
            </div>
            <div>
              <p className="text-white text-[13px] font-bold" style={{ fontFamily: '"Inter", sans-serif' }}>Identité classifiée</p>
              <p className="text-gray-500 text-[11px]" style={{ fontFamily: '"Inter", sans-serif' }}>{trainer.role}</p>
            </div>
          </div>
        </div>

        {hasBooked ? (
          <div className="flex items-center gap-2 px-4 py-3 rounded-lg" style={{ backgroundColor: 'rgba(34,197,94,0.08)', border: '1px solid rgba(34,197,94,0.15)' }}>
            <CheckCircle2 size={16} style={{ color: '#22c55e' }} />
            <span className="text-[13px]" style={{ color: '#22c55e', fontFamily: '"Inter", sans-serif' }}>
              Call réservé ce mois-ci — prochain disponible dans 30 jours
            </span>
          </div>
        ) : (
          <button
            data-testid={`book-call-${moduleId}`}
            onClick={handleBook}
            disabled={booking}
            className="w-full flex items-center justify-center gap-2 px-4 py-3 rounded-lg text-[13px] font-bold transition-all hover:brightness-110 disabled:opacity-50"
            style={{ backgroundColor: '#3b82f6', color: '#0a0e17', fontFamily: '"Inter", sans-serif' }}
          >
            <Calendar size={15} />
            {booking ? 'Réservation...' : 'Réserver mon call'}
          </button>
        )}
      </div>
    </div>
  );
};

/* ─── FORMATION DETAIL ─── */
const FormationDetail = ({ moduleId, onBack, user }) => {
  const mod = formationModules.find((m) => m.id === moduleId);
  const [expandedSection, setExpandedSection] = useState(-1);
  const [activeLesson, setActiveLesson] = useState(null);
  const [scriptLesson, setScriptLesson] = useState(null);
  const [completed, setCompleted] = useState(() => {
    try { return JSON.parse(localStorage.getItem(`progress_${moduleId}`) || '[]'); } catch { return []; }
  });
  const [resetting, setResetting] = useState(false);
  const Icon = iconMap[mod?.icon] || BookOpen;

  // Load progress from backend on mount and merge with localStorage
  useEffect(() => {
    fetch(`${API}/api/user/progress/${moduleId}`, { headers: getAuthHeaders() })
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        if (data?.completed) {
          setCompleted(prev => {
            const merged = [...new Set([...prev, ...data.completed])];
            localStorage.setItem(`progress_${moduleId}`, JSON.stringify(merged));
            return merged;
          });
        }
      })
      .catch(() => {});
  }, [moduleId]);

  if (!mod) return <p className="text-white">Formation introuvable.</p>;
  const totalLessons = mod.sections.reduce((acc, s) => acc + s.lessons.length, 0);
  const allLessons = mod.sections.flatMap(s => s.lessons);
  const completedCount = completed.length;
  const pct = totalLessons > 0 ? Math.round((completedCount / totalLessons) * 100) : 0;

  // Find the next uncompleted lesson for the CTA
  const nextUncompletedLesson = allLessons.find(l => !completed.includes(l.id));
  const isStarted = completedCount > 0;

  const handleComplete = (lessonId) => {
    const next = completed.includes(lessonId) ? completed.filter(id => id !== lessonId) : [...completed, lessonId];
    setCompleted(next);
    localStorage.setItem(`progress_${moduleId}`, JSON.stringify(next));
    fetch(`${API}/api/user/progress`, {
      method: 'POST',
      headers: getAuthHeaders({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({ email: user?.email || '', module_id: moduleId, lesson_id: lessonId, completed: !completed.includes(lessonId) })
    }).catch(() => {});
  };

  const handleResetSection = (sectionLessonIds) => {
    if (!window.confirm('Remettre à zéro cette section ? Toute la progression sera effacée.')) return;
    setResetting(true);
    const next = completed.filter(id => !sectionLessonIds.includes(id));
    setCompleted(next);
    localStorage.setItem(`progress_${moduleId}`, JSON.stringify(next));
    fetch(`${API}/api/user/progress/reset`, {
      method: 'POST',
      headers: getAuthHeaders({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({ email: user?.email || '', module_id: moduleId, lesson_ids: sectionLessonIds })
    }).catch(() => {}).finally(() => setResetting(false));
  };

  const handleResetAll = () => {
    if (!window.confirm('Remettre à zéro TOUTE la formation ? Toute votre progression sera effacée.')) return;
    setResetting(true);
    setCompleted([]);
    localStorage.setItem(`progress_${moduleId}`, JSON.stringify([]));
    fetch(`${API}/api/user/progress/reset`, {
      method: 'POST',
      headers: getAuthHeaders({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({ email: user?.email || '', module_id: moduleId })
    }).catch(() => {}).finally(() => setResetting(false));
  };

  const activeLessonData = activeLesson ? allLessons.find(l => l.id === activeLesson) : null;

  // If a lesson is active, show the LessonView
  if (activeLessonData) {
    return (
      <LessonView
        lesson={{ ...activeLessonData, completed: completed.includes(activeLessonData.id) }}
        module={mod}
        onClose={() => setActiveLesson(null)}
        onComplete={handleComplete}
        allLessons={allLessons.map(l => ({ ...l, completed: completed.includes(l.id) }))}
        onNavigateLesson={(id) => setActiveLesson(id)}
        userEmail={user?.email}
      />
    );
  }

  // Campus images for hero
  const campusImages = {
    musculation: 'https://customer-assets.emergentagent.com/job_634756e7-d357-4658-b587-893379df9990/artifacts/38gaug6t_Upscaled%20Image%20%287%29.png',
    reseaux: 'https://customer-assets.emergentagent.com/job_3c0de952-2f29-471c-a2e0-4fa7608f4c1b/artifacts/1sses6ae_Upscaled%20Image%20%286%29.png',
    montage: 'https://customer-assets.emergentagent.com/job_3c0de952-2f29-471c-a2e0-4fa7608f4c1b/artifacts/4b1wj2x4_Upscaled%20Image%20%282%29.png',
    ia: 'https://customer-assets.emergentagent.com/job_3c0de952-2f29-471c-a2e0-4fa7608f4c1b/artifacts/5m8ob6w8_Upscaled%20Image%20%285%29.png',
    nutrition: 'https://customer-assets.emergentagent.com/job_3c0de952-2f29-471c-a2e0-4fa7608f4c1b/artifacts/oyz55eql_Upscaled%20Image%20%284%29.png',
    filming: 'https://customer-assets.emergentagent.com/job_3c0de952-2f29-471c-a2e0-4fa7608f4c1b/artifacts/i27uci5a_Upscaled%20Image%20%283%29.png',
  };

  // Get upcoming/in-progress lessons for sidebar
  const inProgressLessons = allLessons.filter(l => !completed.includes(l.id)).slice(0, 5);
  const recentCompletedLessons = allLessons.filter(l => completed.includes(l.id)).slice(-3);

  // Selected section for the sidebar lesson list
  const selectedSectionData = expandedSection >= 0 ? mod.sections[expandedSection] : null;

  return (
    <div>
      {scriptLesson && (
        <ScriptModal lesson={scriptLesson} onClose={() => setScriptLesson(null)} />
      )}

      <button onClick={onBack} className="text-gray-500 hover:text-white text-[13px] mb-5 flex items-center gap-1 transition-colors" style={{ fontFamily: '"Inter", sans-serif' }}>
        <ChevronLeft size={16} /> Retour aux programmes
      </button>

      {/* Hero Banner — Glassmorphism */}
      <div className="rounded-2xl overflow-hidden mb-8 relative" style={{ height: 220 }}>
        {campusImages[mod.id] && (
          <img src={campusImages[mod.id]} alt={mod.title} className="absolute inset-0 w-full h-full object-cover" />
        )}
        <div className="absolute inset-0" style={{ background: 'linear-gradient(to right, rgba(8,10,20,0.95) 0%, rgba(8,10,20,0.7) 50%, rgba(8,10,20,0.3) 100%)' }} />
        <div className="relative z-10 h-full flex items-center p-8">
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-[44px] h-[44px] rounded-xl flex items-center justify-center" style={{ backgroundColor: `${mod.color}25`, backdropFilter: 'blur(12px)' }}>
                <Icon size={22} style={{ color: mod.color }} />
              </div>
              <div>
                <h1 className="text-[26px] font-bold text-white" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>{mod.title}</h1>
                <p className="text-gray-400 text-[13px]" style={{ fontFamily: '"Inter", sans-serif' }}>{mod.subtitle}</p>
              </div>
            </div>

            {/* Progress */}
            <div className="flex items-center gap-4 mb-4">
              <div className="w-48 h-2 rounded-full" style={{ backgroundColor: 'rgba(255,255,255,0.1)' }}>
                <div className="h-full rounded-full transition-all duration-500" style={{ width: `${pct}%`, backgroundColor: mod.color }} />
              </div>
              <span className="text-[13px] font-bold" style={{ color: mod.color, fontFamily: '"Inter", sans-serif' }}>{pct}%</span>
              <span className="text-gray-500 text-[12px]" style={{ fontFamily: '"Inter", sans-serif' }}>
                {completedCount}/{totalLessons} leçons terminées
              </span>
            </div>

            {/* CTA */}
            <div className="flex items-center gap-3 flex-wrap">
              {nextUncompletedLesson && (
                <button
                  data-testid="start-formation-btn"
                  onClick={() => setActiveLesson(nextUncompletedLesson.id)}
                  className="flex items-center gap-2.5 px-6 py-3 rounded-xl text-[14px] font-bold transition-all hover:brightness-110 hover:scale-[1.02]"
                  style={{ backgroundColor: '#3b82f6', color: '#ffffff', fontFamily: '"Space Grotesk", sans-serif' }}
                >
                  <Play size={18} className="ml-0.5" />
                  {isStarted ? `Continuer — ${nextUncompletedLesson.title}` : 'Commencer la formation'}
                </button>
              )}
              {!nextUncompletedLesson && completedCount === totalLessons && (
                <div className="flex items-center gap-2 px-5 py-3 rounded-xl text-[14px] font-bold"
                  style={{ backgroundColor: 'rgba(34,197,94,0.15)', color: '#22c55e', fontFamily: '"Space Grotesk", sans-serif' }}>
                  <CheckCircle2 size={18} /> Formation terminée !
                </div>
              )}
              {isStarted && (
                <button
                  data-testid="reset-all-progress-btn"
                  onClick={handleResetAll}
                  disabled={resetting}
                  className="flex items-center gap-1.5 px-4 py-2.5 rounded-xl text-[12px] font-medium transition-all hover:bg-white/[0.06]"
                  style={{ backgroundColor: 'rgba(255,255,255,0.05)', color: '#94a3b8', border: '1px solid rgba(255,255,255,0.08)', backdropFilter: 'blur(8px)', fontFamily: '"Inter", sans-serif' }}
                >
                  <RotateCcw size={13} />
                  Remettre à zéro
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Main 2-column Layout: Module Cards Grid + Sidebar */}
      <div className="flex gap-6 items-start">

        {/* LEFT — Modules Grid */}
        <div className="flex-1 min-w-0">
          <h2 className="text-white text-[18px] font-bold mb-5" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>Mes Modules</h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {mod.sections.map((section, sIdx) => {
              const sectionDone = section.lessons.filter(l => completed.includes(l.id)).length;
              const sectionTotal = section.lessons.length;
              const sectionPct = sectionTotal > 0 ? Math.round((sectionDone / sectionTotal) * 100) : 0;
              const sectionImg = sectionImages[section.title];
              const isSelected = expandedSection === sIdx;
              const allDone = sectionDone === sectionTotal && sectionTotal > 0;

              return (
                <div
                  key={sIdx}
                  data-testid={`section-card-${sIdx}`}
                  onClick={() => setExpandedSection(isSelected ? -1 : sIdx)}
                  className="group cursor-pointer rounded-2xl overflow-hidden transition-all duration-300 hover:scale-[1.02]"
                  style={{
                    background: isSelected ? 'rgba(59,130,246,0.08)' : 'rgba(255,255,255,0.03)',
                    border: isSelected ? '1px solid rgba(59,130,246,0.25)' : '1px solid rgba(255,255,255,0.06)',
                    backdropFilter: 'blur(16px)',
                    WebkitBackdropFilter: 'blur(16px)',
                  }}
                >
                  {/* Card Image */}
                  <div className="relative h-[140px] overflow-hidden">
                    {sectionImg ? (
                      <img src={sectionImg} alt="" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                    ) : (
                      <div className="w-full h-full" style={{ background: `linear-gradient(135deg, ${mod.color}30, rgba(10,14,30,0.9))` }} />
                    )}
                    <div className="absolute inset-0" style={{ background: 'linear-gradient(to top, rgba(8,10,20,0.9) 0%, rgba(8,10,20,0.2) 50%, transparent 100%)' }} />

                    {/* Module badge */}
                    <div className="absolute top-3 left-3 px-2.5 py-1 rounded-lg text-[10px] font-bold"
                      style={{ backgroundColor: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(8px)', color: mod.color, fontFamily: '"Inter", sans-serif', border: '1px solid rgba(255,255,255,0.08)' }}>
                      Module {sIdx + 1}
                    </div>

                    {/* Completion check */}
                    {allDone && (
                      <div className="absolute top-3 right-3 w-7 h-7 rounded-full flex items-center justify-center" style={{ backgroundColor: 'rgba(34,197,94,0.2)', backdropFilter: 'blur(8px)', border: '1px solid rgba(34,197,94,0.3)' }}>
                        <CheckCircle2 size={14} style={{ color: '#22c55e' }} />
                      </div>
                    )}

                    {/* Circular progress at bottom-right */}
                    {!allDone && sectionPct > 0 && (
                      <div className="absolute bottom-3 right-3">
                        <svg width="36" height="36" viewBox="0 0 36 36" className="transform -rotate-90">
                          <circle cx="18" cy="18" r="15" fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="2.5" />
                          <circle cx="18" cy="18" r="15" fill="none" stroke={mod.color} strokeWidth="2.5" strokeLinecap="round"
                            strokeDasharray={`${sectionPct * 0.942} 100`} />
                        </svg>
                        <span className="absolute inset-0 flex items-center justify-center text-[9px] font-bold" style={{ color: mod.color }}>{sectionPct}%</span>
                      </div>
                    )}
                  </div>

                  {/* Card Content */}
                  <div className="p-4">
                    <h3 className="text-white font-bold text-[14px] mb-1 truncate" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>
                      {section.title}
                    </h3>
                    <p className="text-gray-500 text-[11px] mb-3" style={{ fontFamily: '"Inter", sans-serif' }}>
                      {sectionTotal} leçons
                    </p>

                    {/* Mini progress bar */}
                    <div className="flex items-center gap-2">
                      <div className="flex-1 h-1 rounded-full" style={{ backgroundColor: 'rgba(255,255,255,0.06)' }}>
                        <div className="h-full rounded-full transition-all duration-500" style={{ width: `${sectionPct}%`, backgroundColor: allDone ? '#22c55e' : mod.color }} />
                      </div>
                      <span className="text-[10px] font-bold" style={{ color: allDone ? '#22c55e' : mod.color, fontFamily: '"Inter", sans-serif' }}>
                        {sectionPct}%
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Expanded Section Lessons — Glassmorphism panel */}
          {selectedSectionData && (
            <div className="mt-5 rounded-2xl overflow-hidden" style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)', backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)' }}>
              <div className="flex items-center justify-between p-4" style={{ borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                <div className="flex items-center gap-3">
                  <span className="text-[11px] font-bold px-2.5 py-1 rounded-lg" style={{ backgroundColor: `${mod.color}15`, color: mod.color }}>
                    Module {expandedSection + 1}
                  </span>
                  <h3 className="text-white font-bold text-[15px]" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>{selectedSectionData.title}</h3>
                </div>
                {selectedSectionData.lessons.filter(l => completed.includes(l.id)).length > 0 && (
                  <button
                    data-testid={`reset-section-${expandedSection}-btn`}
                    onClick={() => handleResetSection(selectedSectionData.lessons.map(l => l.id))}
                    disabled={resetting}
                    className="flex items-center gap-1 px-2.5 py-1 rounded-md text-[10px] font-medium transition-all hover:bg-white/[0.05]"
                    style={{ color: '#94a3b8', fontFamily: '"Inter", sans-serif' }}
                  >
                    <RotateCcw size={10} /> Remettre à zéro
                  </button>
                )}
              </div>
              {selectedSectionData.lessons.map((lesson, lIdx) => {
                const isDone = completed.includes(lesson.id);
                return (
                  <div
                    key={lesson.id}
                    data-testid={`lesson-${lesson.id}`}
                    onClick={() => setActiveLesson(lesson.id)}
                    className="flex items-center gap-3 px-5 py-3.5 hover:bg-white/[0.03] cursor-pointer transition-colors group"
                  >
                    <div className="w-[30px] h-[30px] rounded-full flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform"
                      style={{ backgroundColor: isDone ? 'rgba(34,197,94,0.15)' : `${mod.color}12`, border: isDone ? '1px solid rgba(34,197,94,0.25)' : `1px solid ${mod.color}20` }}>
                      {isDone ? <CheckCircle2 size={13} style={{ color: '#22c55e' }} /> : <span className="text-[11px] font-bold" style={{ color: mod.color }}>{lIdx + 1}</span>}
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className={`text-[13px] truncate transition-colors ${isDone ? 'text-gray-600' : 'text-gray-300 group-hover:text-white'}`} style={{ fontFamily: '"Inter", sans-serif' }}>
                        {lesson.title}
                      </p>
                      <p className="text-[10px] text-gray-600 mt-0.5" style={{ fontFamily: '"Inter", sans-serif' }}>{lesson.duration}</p>
                    </div>
                    <button
                      onClick={(e) => { e.stopPropagation(); setActiveLesson(lesson.id); }}
                      className="flex items-center gap-1 px-3 py-1.5 rounded-lg text-[11px] font-medium opacity-0 group-hover:opacity-100 transition-all flex-shrink-0"
                      style={{ backgroundColor: isDone ? 'rgba(34,197,94,0.1)' : `${mod.color}15`, color: isDone ? '#22c55e' : mod.color, fontFamily: '"Inter", sans-serif' }}
                    >
                      {isDone ? 'Revoir' : 'Ouvrir'} <ArrowRight size={12} />
                    </button>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* RIGHT — Sidebar */}
        <div className="hidden lg:block w-[320px] flex-shrink-0 space-y-5">

          {/* Call Booking — Glassmorphism */}
          <CallBookingWidget moduleId={mod.id} user={user} />

          {/* Leçons en cours — Glassmorphism */}
          <div className="rounded-2xl overflow-hidden" style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)', backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)' }}>
            <div className="p-5">
              <h3 className="text-white font-bold text-[14px] mb-4" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>Leçons en cours</h3>

              {inProgressLessons.length === 0 && recentCompletedLessons.length === 0 && (
                <p className="text-gray-600 text-[12px]" style={{ fontFamily: '"Inter", sans-serif' }}>Aucune leçon commencée</p>
              )}

              <div className="space-y-1">
                {inProgressLessons.map((lesson) => (
                  <div
                    key={lesson.id}
                    onClick={() => setActiveLesson(lesson.id)}
                    className="flex items-center gap-3 p-2.5 rounded-xl cursor-pointer hover:bg-white/[0.04] transition-colors group"
                  >
                    <div className="w-[28px] h-[28px] rounded-full flex items-center justify-center flex-shrink-0"
                      style={{ backgroundColor: `${mod.color}12`, border: `1px solid ${mod.color}25` }}>
                      <Play size={10} style={{ color: mod.color }} />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-gray-300 text-[12px] truncate group-hover:text-white transition-colors" style={{ fontFamily: '"Inter", sans-serif' }}>{lesson.title}</p>
                      <p className="text-gray-600 text-[10px]" style={{ fontFamily: '"Inter", sans-serif' }}>{lesson.duration}</p>
                    </div>
                  </div>
                ))}
                {recentCompletedLessons.map((lesson) => (
                  <div
                    key={lesson.id}
                    onClick={() => setActiveLesson(lesson.id)}
                    className="flex items-center gap-3 p-2.5 rounded-xl cursor-pointer hover:bg-white/[0.04] transition-colors"
                  >
                    <div className="w-[28px] h-[28px] rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: 'rgba(34,197,94,0.12)', border: '1px solid rgba(34,197,94,0.2)' }}>
                      <CheckCircle2 size={11} style={{ color: '#22c55e' }} />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-gray-600 text-[12px] truncate" style={{ fontFamily: '"Inter", sans-serif' }}>{lesson.title}</p>
                      <p className="text-gray-700 text-[10px]" style={{ fontFamily: '"Inter", sans-serif' }}>{lesson.duration}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

/* ─── MONK MODE ─── */
const MonkMode = ({ user }) => {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [booking, setBooking] = useState(false);
  const trainer = trainers.monkmode;

  useEffect(() => {
    if (user?.email) {
      fetch(`${API}/api/call/status?email=${encodeURIComponent(user.email)}`)
        .then(r => r.json()).then(setStatus).catch(() => {}).finally(() => setLoading(false));
    } else { setLoading(false); }
  }, [user?.email]);

  const handleBookCall = async () => {
    if (!user?.email) return;
    setBooking(true);
    try {
      const res = await fetch(`${API}/api/call/book`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: user.email, module_id: 'monkmode', trainer_name: trainer.name }),
      });
      if (!res.ok) {
        const err = await res.json();
        alert(err.detail || 'Erreur');
        setBooking(false);
        return;
      }
      window.open(trainer.calendly, '_blank');
      const updated = await fetch(`${API}/api/call/status?email=${encodeURIComponent(user.email)}`).then(r => r.json());
      setStatus(updated);
    } catch { alert('Erreur de connexion'); }
    setBooking(false);
  };

  const isActive = status?.monk_mode_active;
  const isPending = status?.monk_mode_pending;

  return (
    <div>
      <h1 className="text-[26px] font-bold mb-0.5" style={{ fontFamily: '"Space Grotesk", sans-serif', color: '#FFFFFF' }}>Monk Mode</h1>
      <p className="text-gray-500 text-[14px] mb-6" style={{ fontFamily: '"Inter", sans-serif' }}>Discipline extrême. Résultats extrêmes.</p>
      <div className="h-[1px] mb-6" style={{ backgroundColor: 'rgba(255,255,255,0.06)' }} />

      {isActive ? (
        /* MONK MODE ACTIVÉ */
        <div className="rounded-xl p-8 text-center" style={{ backgroundColor: 'rgba(59,130,246,0.04)', border: '1px solid rgba(59,130,246,0.15)' }}>
          <div className="w-20 h-20 rounded-full mx-auto mb-4 flex items-center justify-center" style={{ backgroundColor: 'rgba(59,130,246,0.1)' }}>
            <Flame size={40} style={{ color: '#3b82f6' }} />
          </div>
          <h3 className="text-white text-[22px] font-bold mb-2" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>Monk Mode Activé</h3>
          <p className="text-gray-400 text-[14px] max-w-md mx-auto mb-6" style={{ fontFamily: '"Inter", sans-serif' }}>
            90 jours de discipline pure. Zéro distraction. Routine stricte. Entraînement quotidien. Tu es en mode guerrier.
          </p>
          <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg" style={{ backgroundColor: 'rgba(34,197,94,0.1)', border: '1px solid rgba(34,197,94,0.2)' }}>
            <CheckCircle2 size={16} style={{ color: '#22c55e' }} />
            <span className="text-[13px] font-bold" style={{ color: '#22c55e', fontFamily: '"Inter", sans-serif' }}>Protocol en cours</span>
          </div>
        </div>
      ) : (
        /* MONK MODE VERROUILLÉ */
        <div className="rounded-xl overflow-hidden" style={{ backgroundColor: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.06)' }}>
          <div className="p-8 text-center">
            <div className="w-20 h-20 rounded-full mx-auto mb-5 flex items-center justify-center" style={{ backgroundColor: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)' }}>
              <Lock size={32} style={{ color: 'rgba(255,255,255,0.2)' }} />
            </div>
            <h3 className="text-white text-[20px] font-bold mb-2" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>90 Jours de Discipline Pure</h3>
            <p className="text-gray-500 text-[14px] max-w-lg mx-auto mb-2" style={{ fontFamily: '"Inter", sans-serif' }}>
              Zéro distraction. Routine stricte. Entraînement quotidien. Nutrition optimisée. Le protocole ultime pour une transformation totale.
            </p>
            <p className="text-[13px] mb-6" style={{ color: '#3b82f6', fontFamily: '"Inter", sans-serif' }}>
              L'activation du Monk Mode nécessite un call avec le fondateur.
            </p>

            {/* Trainer card */}
            <div className="inline-block rounded-xl p-5 mb-6 text-left" style={{ backgroundColor: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)', minWidth: 300 }}>
              <div className="flex items-center gap-4">
                <div className="w-[48px] h-[48px] rounded-full flex items-center justify-center text-[15px] font-bold" style={{ backgroundColor: 'rgba(59,130,246,0.12)', color: '#3b82f6', fontFamily: '"Space Grotesk", sans-serif' }}>
                  GB
                </div>
                <div>
                  <p className="text-white text-[15px] font-bold" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>Gaut Bonac</p>
                  <p className="text-gray-500 text-[12px]" style={{ fontFamily: '"Inter", sans-serif' }}>Fondateur OpenRoom</p>
                </div>
              </div>
            </div>

            <div className="flex flex-col items-center gap-3">
              {isPending ? (
                <div className="flex items-center gap-2 px-5 py-3 rounded-lg" style={{ backgroundColor: 'rgba(59,130,246,0.06)', border: '1px solid rgba(59,130,246,0.15)' }}>
                  <Calendar size={16} style={{ color: '#3b82f6' }} />
                  <span className="text-[13px] font-bold" style={{ color: '#3b82f6', fontFamily: '"Inter", sans-serif' }}>
                    Call réservé — Monk Mode sera activé après l'appel
                  </span>
                </div>
              ) : (
                <button
                  data-testid="book-monkmode-call"
                  onClick={handleBookCall}
                  disabled={booking || loading}
                  className="flex items-center gap-2 px-8 py-3 rounded-lg text-[14px] font-bold transition-all hover:brightness-110 disabled:opacity-50"
                  style={{ backgroundColor: '#3b82f6', color: '#0a0e17', fontFamily: '"Inter", sans-serif' }}
                >
                  <Phone size={16} />
                  {booking ? 'Réservation...' : 'Réserver le call d\'activation'}
                </button>
              )}
              <p className="text-gray-600 text-[11px]" style={{ fontFamily: '"Inter", sans-serif' }}>
                Appel de 30 min — Définir ton emploi du temps et tes objectifs
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

/* ─── RESOURCES ─── */
const ResourcesPage = () => (
  <div>
    <h1 className="text-[26px] font-bold mb-0.5" style={{ fontFamily: '"Space Grotesk", sans-serif', color: '#FFFFFF' }}>Ressources</h1>
    <p className="text-gray-500 text-[14px] mb-6" style={{ fontFamily: '"Inter", sans-serif' }}>Templates, guides et outils</p>
    <div className="h-[1px] mb-6" style={{ backgroundColor: 'rgba(255,255,255,0.06)' }} />
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {[
        { title: 'Templates de Scripts Vidéo', desc: '30 templates prêts à l\'emploi', icon: '📝' },
        { title: 'Guide Nutrition PDF', desc: 'Plans alimentaires complets', icon: '🥗' },
        { title: 'Prompts IA Collection', desc: '100+ prompts ChatGPT/Claude', icon: '🤖' },
        { title: 'Checklist Monk Mode', desc: 'Routine quotidienne 90 jours', icon: '🔥' },
        { title: 'Pack Presets Montage', desc: 'LUTs, transitions, effets', icon: '🎬' },
        { title: 'Guide E-commerce', desc: 'De 0 à ta première vente', icon: '💰' },
      ].map((r, i) => (
        <div key={i} className="rounded-xl p-5 cursor-pointer hover:bg-white/[0.05] transition-all" style={{ backgroundColor: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)' }}>
          <span className="text-[28px]">{r.icon}</span>
          <h3 className="text-white font-bold text-[15px] mt-3 mb-1" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>{r.title}</h3>
          <p className="text-gray-500 text-[12px]" style={{ fontFamily: '"Inter", sans-serif' }}>{r.desc}</p>
        </div>
      ))}
    </div>
  </div>
);

/* ─── SUPPORT ─── */
const SupportPage = () => (
  <div>
    <h1 className="text-[26px] font-bold mb-0.5" style={{ fontFamily: '"Space Grotesk", sans-serif', color: '#FFFFFF' }}>Support</h1>
    <p className="text-gray-500 text-[14px] mb-6" style={{ fontFamily: '"Inter", sans-serif' }}>Besoin d'aide ? On est là.</p>
    <div className="h-[1px] mb-6" style={{ backgroundColor: 'rgba(255,255,255,0.06)' }} />
    <div className="space-y-4">
      <a href={TELEGRAM_URL} target="_blank" rel="noopener noreferrer" data-testid="support-telegram-link" className="block rounded-xl p-6 hover:bg-white/[0.05] transition-all no-underline" style={{ backgroundColor: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)' }}>
        <div className="flex items-center gap-4">
          <div className="w-[48px] h-[48px] rounded-xl flex items-center justify-center" style={{ backgroundColor: 'rgba(0, 136, 204, 0.15)' }}>
            <Users size={24} style={{ color: '#0088cc' }} />
          </div>
          <div className="flex-1">
            <h3 className="text-white font-bold text-[16px]" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>Communauté Telegram</h3>
            <p className="text-gray-500 text-[13px] mt-0.5" style={{ fontFamily: '"Inter", sans-serif' }}>Pose tes questions aux autres membres et à l'équipe</p>
          </div>
          <ExternalLink size={16} className="text-gray-600" />
        </div>
      </a>
      <div className="rounded-xl p-6" style={{ backgroundColor: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)' }}>
        <div className="flex items-center gap-4">
          <div className="w-[48px] h-[48px] rounded-xl flex items-center justify-center" style={{ backgroundColor: 'rgba(59, 130, 246, 0.1)' }}>
            <HelpCircle size={24} style={{ color: '#3b82f6' }} />
          </div>
          <div className="flex-1">
            <h3 className="text-white font-bold text-[16px]" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>Email Support</h3>
            <p className="text-gray-500 text-[13px] mt-0.5" style={{ fontFamily: '"Inter", sans-serif' }}>contact@openroom.com — Réponse sous 24h</p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

/* ─── AFFILIATE PORTAL ─── */
const AffiliatePage = () => (
  <div>
    <h1 className="text-[26px] font-bold mb-0.5" style={{ fontFamily: '"Space Grotesk", sans-serif', color: '#FFFFFF' }}>Portail Affilié</h1>
    <p className="text-gray-500 text-[14px] mb-6" style={{ fontFamily: '"Inter", sans-serif' }}>Gagne de l'argent en partageant OpenRoom</p>
    <div className="h-[1px] mb-6" style={{ backgroundColor: 'rgba(255,255,255,0.06)' }} />
    <div className="rounded-xl p-6" style={{ backgroundColor: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)' }}>
      <h3 className="text-white font-bold text-[18px] mb-4" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>Ton lien affilié</h3>
      <div className="flex gap-2">
        <input readOnly value="https://openroom.com/ref/gautbonac" className="flex-1 px-4 py-3 text-[13px] text-gray-300 rounded-md border border-gray-700 focus:outline-none" style={{ backgroundColor: 'rgba(0,0,0,0.3)', fontFamily: '"Inter", sans-serif' }} />
        <button className="px-6 py-3 text-[#0a0e17] font-bold text-[13px] rounded-md hover:brightness-110 transition-all" style={{ backgroundColor: '#3b82f6', fontFamily: '"Inter", sans-serif' }}>
          COPIER
        </button>
      </div>
      <div className="grid grid-cols-3 gap-4 mt-6">
        <div className="text-center p-4 rounded-lg" style={{ backgroundColor: 'rgba(255,255,255,0.02)' }}>
          <p className="text-[#3b82f6] text-[24px] font-bold" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>0</p>
          <p className="text-gray-500 text-[11px] mt-1" style={{ fontFamily: '"Inter", sans-serif' }}>Clics</p>
        </div>
        <div className="text-center p-4 rounded-lg" style={{ backgroundColor: 'rgba(255,255,255,0.02)' }}>
          <p className="text-[#3b82f6] text-[24px] font-bold" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>0</p>
          <p className="text-gray-500 text-[11px] mt-1" style={{ fontFamily: '"Inter", sans-serif' }}>Inscrits</p>
        </div>
        <div className="text-center p-4 rounded-lg" style={{ backgroundColor: 'rgba(255,255,255,0.02)' }}>
          <p className="text-[#3b82f6] text-[24px] font-bold" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>0€</p>
          <p className="text-gray-500 text-[11px] mt-1" style={{ fontFamily: '"Inter", sans-serif' }}>Gains</p>
        </div>
      </div>
    </div>
  </div>
);

/* ─── SETTINGS ─── */
const SettingsPage = ({ user }) => (
  <div>
    <h1 className="text-[26px] font-bold mb-0.5" style={{ fontFamily: '"Space Grotesk", sans-serif', color: '#FFFFFF' }}>Paramètres</h1>
    <p className="text-gray-500 text-[14px] mb-6" style={{ fontFamily: '"Inter", sans-serif' }}>Gère ton compte</p>
    <div className="h-[1px] mb-6" style={{ backgroundColor: 'rgba(255,255,255,0.06)' }} />
    <div className="rounded-xl p-6 max-w-lg" style={{ backgroundColor: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)' }}>
      <div className="space-y-4">
        <div>
          <label className="text-gray-400 text-[12px] mb-1 block" style={{ fontFamily: '"Inter", sans-serif' }}>Nom</label>
          <input readOnly value={user?.name || ''} className="w-full px-4 py-3 text-[14px] text-gray-300 rounded-md border border-gray-700" style={{ backgroundColor: 'rgba(0,0,0,0.3)', fontFamily: '"Inter", sans-serif' }} />
        </div>
        <div>
          <label className="text-gray-400 text-[12px] mb-1 block" style={{ fontFamily: '"Inter", sans-serif' }}>Email</label>
          <input readOnly value={user?.email || ''} className="w-full px-4 py-3 text-[14px] text-gray-300 rounded-md border border-gray-700" style={{ backgroundColor: 'rgba(0,0,0,0.3)', fontFamily: '"Inter", sans-serif' }} />
        </div>
      </div>
    </div>
  </div>
);

/* ─── MAIN DASHBOARD ─── */
const Dashboard = ({ user, onLogout }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState('dashboard');
  const [selectedFormation, setSelectedFormation] = useState(null);

  useEffect(() => {
    const f = searchParams.get('formation');
    if (f && formationModules.some(m => m.id === f)) {
      setSelectedFormation(f);
      setActiveTab('formation-detail');
    }
  }, [searchParams]);

  const handleLogout = () => {
    if (onLogout) onLogout();
    navigate('/');
  };

  const handleNavigateFormation = (moduleId) => {
    setSelectedFormation(moduleId);
    setActiveTab('formation-detail');
  };

  const renderContent = () => {
    if (activeTab === 'formation-detail' && selectedFormation) {
      return <FormationDetail moduleId={selectedFormation} onBack={() => { setSelectedFormation(null); setActiveTab('programmes'); }} user={user} />;
    }
    switch (activeTab) {
      case 'programmes': return <ProgramsList onNavigateFormation={handleNavigateFormation} />;
      case 'monk-mode': return <MonkMode user={user} />;
      case 'ressources': return <ResourcesPage />;
      case 'support': return <SupportPage />;
      case 'affiliate': return <AffiliatePage />;
      case 'parametres': return <SettingsPage user={user} />;
      default: return <DashboardHome user={user} onNavigateFormation={handleNavigateFormation} onNavigateProgrammes={() => setActiveTab('programmes')} />;
    }
  };

  return (
    <div className="flex min-h-screen" style={{ backgroundColor: '#0a0e17' }}>
      <Sidebar user={user} onLogout={handleLogout} activeTab={activeTab} setActiveTab={(tab) => { setActiveTab(tab); setSelectedFormation(null); }} />
      <main className="flex-1 p-6 lg:p-8 overflow-auto flex flex-col" style={{ height: '100vh' }}>
        <div className="flex-1 min-h-0">
          {renderContent()}
        </div>
      </main>
    </div>
  );
};

export default Dashboard;
